import _ from 'lodash';
import { ChannelAssumptions } from './ChannelAssumptions';
import { FlexibleObj } from '../interfaces/FlexibleObj';
import { Product } from './Product';

export enum DocTypes {
  amendment = 'amendment',
  Application = 'Application',
  AdditionalDetails = 'AdditionalDetails',
  AviationSupp = 'AviationSupp',
  AvocationSupp = 'AvocationSupp',
  TravelForm = 'TravelForm',
  BeneDesgination = 'BeneDesgination',
  OwnerDesignation = 'OwnerDesignation',
  ACBRDisclosure = 'ACBRDisclosure',
  StateDisclosure = 'StateDisclosure',
  MiscSupp = 'MiscSupp',
  appPacket = 'appPacket',
  appPacketSI = 'appPacketSI',
  appPacketTerm2 = 'appPacketTerm2',
  HIPPA = 'HIPPA',
  Replace = 'Replace',
  BasicIllustration = 'BasicIllustration',
  A2200 = 'A2200',
  visa = 'visa',
  i797 = 'i797',
  archive = 'archive',
  Identification = 'Identification',
  CustomerUpload = 'CustomerUpload',
  ThirdPartyPayer = 'Payment Plan Pre-Authorization',
  CollateralAssignment = 'Collateral Assignment',
  NonIncorporatedEntityOwner = 'Non-Incorporated Entity F7833',
  EntityOwnershipNonMA = 'Entity Ownership F7004',
  EntityOwnershipMA = 'Entity Ownership F7004MA',
  Trust = 'Certification of Trust',
  Insurability = 'Insurability',
  AdditionalPacket = 'AdditionalPacket',
  FR2217 = 'FR2217',
  FR2200 = 'FR2200',
  CIRDisclosure = 'CIR Disclosure',
  FR3010 = 'FR3010',
}

const assumptions: FlexibleObj<any> = {
  doLaddering: false,
  doSpouse: false,
  percentIsOfBothIncomes: false,
  commissionTerm: 1.1,
  taxRate: 0.35,
  retirementAge: 65,
  SSNAge: 66,
  leaveTheNestAge: 21,
  startsWorkingAt: 25,
  mortalityAge: 90,
  inflation: 0.025,
  collegeInflation: 0.08,
  discountRate: 0.04,
  debtPaydownRatio: 0.05,
  retirementRate: 0.05,
  contributionRate: 0.1,
  termThreshold: 0,
  healthCareMonthlyNoKids: 200,
  healthCareMonthlyWithKids: 400,
  ssnCOLA: 0.017,
  ssnMaxIncome: {
    '2014': 15480,
  },
  savingsRate: 0.05,
  healthCareSalaryThreshold: 4e4,
  startCollege: 18,
  medicareYear: 65,
  PIABendPoints: [816, 4917],
  FMBendPoints: [1042, 1505, 1962],
  bendPointYear: 2014,
  earlyRetirementAdjustments: {
    '1': 0.9333333333333333,
    '2': 0.8666666666666667,
    '3': 0.8,
    '4': 0.75,
    '5': 0.7,
  },
  maxTermLength: 30,
  defaultMaxFaceForNoLabs: 750000,
  healthClassNoThreshold: 0.1,
  healthClassYesThreshold: 0.25,
  bloodPressureSystolic: {
    '1': 130,
    '2': 140,
    '3': 150,
  },
  bloodPressureDystolic: {
    '1': 80,
    '2': 90,
    '3': 100,
  },
  allowSurplus: true,
  useSSNSurvirorBenefits: false,
  metadataKeys: {
    categories: {
      AppQuestions: 'App_Questions',
      GeneralBusinessRules: 'General Business Rules',
      Workflow: 'Workflow',
    },
  },
  get metadataCategories() {
    return _.values(this.metadataKeys.categories);
  },
  languages: {
    en: 'English',
    es: 'Spanish',
  },
  languageCodes: {
    English: 'en',
    Spanish: 'es',
  },
  ssnTable: {
    '1951': [3600, 14.89],
    '1952': [3600, 14.02],
    '1953': [3600, 13.27],
    '1954': [3600, 13.21],
    '1955': [4200, 12.62],
    '1956': [4200, 11.8],
    '1957': [4200, 11.44],
    '1958': [4200, 11.34],
    '1959': [4800, 10.81],
    '1960': [4800, 10.4],
    '1961': [4800, 10.2],
    '1962': [4800, 9.71],
    '1963': [4800, 9.48],
    '1964': [4800, 9.11],
    '1965': [4800, 8.95],
    '1966': [6600, 8.44],
    '1967': [6600, 7.99],
    '1968': [7800, 7.48],
    '1969': [7800, 7.07],
    '1970': [7800, 6.74],
    '1971': [7800, 6.41],
    '1972': [9e3, 5.84],
    '1973': [10800, 5.5],
    '1974': [13200, 5.19],
    '1975': [14100, 4.83],
    '1976': [15300, 4.52],
    '1977': [16500, 4.26],
    '1978': [17700, 3.95],
    '1979': [22900, 3.63],
    '1980': [25900, 3.33],
    '1981': [29700, 3.03],
    '1982': [32400, 2.87],
    '1983': [35700, 2.73],
    '1984': [37800, 2.58],
    '1985': [39600, 2.48],
    '1986': [42e3, 2.41],
    '1987': [43800, 2.26],
    '1988': [45e3, 2.16],
    '1989': [48e3, 2.07],
    '1990': [51300, 1.98],
    '1991': [53400, 1.91],
    '1992': [55500, 1.82],
    '1993': [57600, 1.8],
    '1994': [60600, 1.75],
    '1995': [61200, 1.69],
    '1996': [62700, 1.61],
    '1997': [65400, 1.52],
    '1998': [68400, 1.44],
    '1999': [72600, 1.37],
    '2000': [76200, 1.3],
    '2001': [80400, 1.27],
    '2002': [84900, 1.25],
    '2003': [87e3, 1.22],
    '2004': [87900, 1.17],
    '2005': [9e4, 1.13],
    '2006': [94200, 1.08],
    '2007': [97500, 1.03],
    '2008': [102e3, 1.01],
    '2009': [106800, 1.02],
    '2010': [106800, 1],
    '2011': [106800, 1],
    '2012': [106800, 1],
    '2013': [106800, 1],
    '2014': [106800, 1],
    '2015': [106800, 1],
  },
  requiredWithdrawls: {
    '0': 82.4,
    '1': 81.6,
    '2': 80.6,
    '3': 79.7,
    '4': 78.7,
    '5': 77.7,
    '6': 76.7,
    '7': 75.8,
    '8': 74.8,
    '9': 73.8,
    '10': 72.8,
    '11': 71.8,
    '12': 70.8,
    '13': 69.9,
    '14': 68.9,
    '15': 67.9,
    '16': 66.9,
    '17': 66,
    '18': 65,
    '19': 64,
    '20': 63,
    '21': 62.1,
    '22': 61.1,
    '23': 60.1,
    '24': 59.1,
    '25': 58.2,
    '26': 57.2,
    '27': 56.2,
    '28': 55.3,
    '29': 54.3,
    '30': 53.3,
    '31': 52.4,
    '32': 51.4,
    '33': 50.4,
    '34': 49.4,
    '35': 48.5,
    '36': 47.5,
    '37': 46.5,
    '38': 45.6,
    '39': 44.6,
    '40': 43.6,
    '41': 42.7,
    '42': 41.7,
    '43': 40.7,
    '44': 39.8,
    '45': 38.8,
    '46': 37.9,
    '47': 37,
    '48': 36,
    '49': 35.1,
    '50': 34.2,
    '51': 33.3,
    '52': 32.3,
    '53': 31.4,
    '54': 30.5,
    '55': 29.6,
    '56': 28.7,
    '57': 27.9,
    '58': 27,
    '59': 26.1,
    '60': 25.2,
    '61': 24.4,
    '62': 23.5,
    '63': 22.7,
    '64': 21.8,
    '65': 21,
    '66': 20.2,
    '67': 19.4,
    '68': 18.6,
    '69': 17.8,
    '70': 17,
    '71': 16.3,
    '72': 15.5,
    '73': 14.8,
    '74': 14.1,
    '75': 13.4,
    '76': 12.7,
    '77': 12.1,
    '78': 11.4,
    '79': 10.8,
    '80': 10.2,
    '81': 9.7,
    '82': 9.1,
    '83': 8.6,
    '84': 8.1,
    '85': 7.6,
    '86': 7.1,
    '87': 6.7,
    '88': 6.3,
    '89': 5.9,
    '90': 5.5,
    '91': 5.2,
    '92': 4.9,
    '93': 4.6,
    '94': 4.3,
    '95': 4.1,
    '96': 3.8,
    '97': 3.6,
    '98': 3.4,
    '99': 3.1,
    '100': 2.9,
    '101': 2.7,
    '102': 2.5,
    '103': 2.3,
    '104': 2.1,
    '105': 1.9,
    '106': 1.7,
    '107': 1.5,
    '108': 1.4,
    '109': 1.2,
    '110': 1.1,
  },
  collegeCosts: {
    community2yr: {
      tuition: 2963,
      period: 2,
      books: 1182,
      board: 7408,
      living: 3733,
      incomeThreshold: 0,
      name: 'community college',
    },
    inState4yr: {
      tuition: 8244,
      period: 4,
      books: 1168,
      board: 8887,
      living: 3148,
      incomeThreshold: 5e4,
      name: 'in-state college',
    },
    outState4yr: {
      tuition: 20770,
      period: 4,
      books: 1168,
      board: 8887,
      living: 3148,
      incomeThreshold: 1e5,
      name: 'out-of-state college',
    },
    private4yr: {
      tuition: 28500,
      period: 4,
      books: 1213,
      board: 10089,
      living: 2422,
      incomeThreshold: 15e4,
      name: 'private college',
    },
  },
  stateCode: {
    AL: 1,
    AK: 2,
    AZ: 3,
    AR: 4,
    CA: 5,
    CO: 6,
    CT: 7,
    DE: 8,
    DC: 9,
    FL: 10,
    GA: 11,
    HI: 12,
    ID: 13,
    IL: 14,
    IN: 15,
    IA: 16,
    KS: 17,
    KY: 18,
    LA: 19,
    ME: 20,
    MD: 21,
    MA: 22,
    MI: 23,
    MN: 24,
    MO: 26,
    MS: 25,
    MT: 27,
    NE: 28,
    NV: 29,
    NH: 30,
    NJ: 31,
    NM: 32,
    NY: 52,
    NC: 34,
    ND: 35,
    OH: 36,
    OK: 37,
    OR: 38,
    PA: 39,
    PR: 54,
    RI: 40,
    SC: 41,
    SD: 42,
    TN: 43,
    TX: 44,
    UT: 45,
    VT: 46,
    VA: 47,
    WA: 48,
    WV: 49,
    WI: 50,
    WY: 51,
  },
  stateGroups: {
    ICC: {
      AL: 'Alabama',
      AK: 'Alaska',
      AZ: 'Arizona',
      AR: 'Arkansas',
      CO: 'Colorado',
      CT: 'Connecticut',
      DC: 'District of Columbia',
      GA: 'Georgia',
      HI: 'Hawaii',
      ID: 'Idaho',
      IL: 'Illinois',
      IN: 'Indiana',
      IA: 'Iowa',
      KS: 'Kansas',
      KY: 'Kentucky',
      LA: 'Louisiana',
      MS: 'Mississippi',
      ME: 'Maine',
      MD: 'Maryland',
      MA: 'Massachusetts',
      MI: 'Michigan',
      MN: 'Minnesota',
      MO: 'Missouri',
      MT: 'Montana',
      NE: 'Nebraska',
      NV: 'Nevada',
      NH: 'New Hampshire',
      NJ: 'New Jersey',
      NM: 'New Mexico',
      NC: 'North Carolina',
      OH: 'Ohio',
      OK: 'Oklahoma',
      OR: 'Oregon',
      PA: 'Pennsylvania',
      PR: 'Puerto Rico',
      RI: 'Rhode Island',
      SC: 'South Carolina',
      TN: 'Tennessee',
      TX: 'Texas',
      UT: 'Utah',
      VT: 'Vermont',
      VA: 'Virginia',
      WA: 'Washington',
      WV: 'West Virginia',
      WI: 'Wisconsin',
      WY: 'Wyoming',
    },
    NonICC: {
      CA: 'California',
      DE: 'Delaware',
      FL: 'Florida',
      ND: 'North Dakota',
      NY: 'New York',
      SD: 'South Dakota',
    },
  },
  stateValues: {
    AL: 'Alabama',
    AK: 'Alaska',
    AZ: 'Arizona',
    AR: 'Arkansas',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    DC: 'District of Columbia',
    FL: 'Florida',
    GA: 'Georgia',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    MS: 'Mississippi',
    ME: 'Maine',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    PR: 'Puerto Rico',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VA: 'Virginia',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming',
  },
  countyValues: {
    'Alabama': [
      'Autauga',
      'Baldwin',
      'Barbour',
      'Bibb',
      'Blount',
      'Bullock',
      'Butler',
      'Calhoun',
      'Chambers',
      'Cherokee',
      'Chilton',
      'Choctaw',
      'Clarke',
      'Clay',
      'Cleburne',
      'Coffee',
      'Colbert',
      'Conecuh',
      'Coosa',
      'Covington',
      'Crenshaw',
      'Cullman',
      'Dale',
      'Dallas',
      'DeKalb',
      'Elmore',
      'Escambia',
      'Etowah',
      'Fayette',
      'Franklin',
      'Geneva',
      'Greene',
      'Hale',
      'Henry',
      'Houston',
      'Jackson',
      'Jefferson',
      'Lamar',
      'Lauderdale',
      'Lawrence',
      'Lee',
      'Limestone',
      'Lowndes',
      'Macon',
      'Madison',
      'Marengo',
      'Marion',
      'Marshall',
      'Mobile',
      'Monroe',
      'Montgomery',
      'Morgan',
      'Perry',
      'Pickens',
      'Pike',
      'Randolph',
      'Russell',
      'Shelby',
      'St. Clair',
      'Sumter',
      'Talladega',
      'Tallapoosa',
      'Tuscaloosa',
      'Walker',
      'Washington',
      'Wilcox',
      'Winston',
    ],
    'Alaska': [
      'Anchorage',
      'Bethel',
      'Bristol Bay',
      'Dillingham',
      'Fairbanks North Star',
      'Haines',
      'Juneau',
      'Kenai Peninsula',
      'Ketchikan Gateway',
      'Kodiak Island',
      'Matanuska-Susitna',
      'Nome',
      'North Slope',
      'Prince of Wales-Outer Ketchikan',
      'Sitka',
      'Skagway-Hoonah-Angoon',
      'Southeast Fairbanks',
      'Valdez-Cordova',
      'Wade Hampton',
      'Wrangell-Petersburg',
      'Yakutat',
      'Yukon-Koyukuk',
    ],
    'Arizona': [
      'Apache',
      'Cochise',
      'Coconino',
      'Gila',
      'Graham',
      'Greenlee',
      'La Paz',
      'Maricopa',
      'Mohave',
      'Navajo',
      'Pima',
      'Pinal',
      'Santa Cruz',
      'Yavapai',
      'Yuma',
    ],
    'Arkansas': [
      'Arkansas',
      'Ashley',
      'Baxter',
      'Benton',
      'Boone',
      'Bradley',
      'Calhoun',
      'Carroll',
      'Chicot',
      'Clark',
      'Clay',
      'Cleburne',
      'Cleveland',
      'Columbia',
      'Conway',
      'Craighead',
      'Crawford',
      'Crittenden',
      'Cross',
      'Dallas',
      'Desha',
      'Drew',
      'Faulkner',
      'Franklin',
      'Fulton',
      'Garland',
      'Grant',
      'Greene',
      'Hempstead',
      'Hot Spring',
      'Howard',
      'Independence',
      'Izard',
      'Jackson',
      'Jefferson',
      'Johnson',
      'Lafayette',
      'Lawrence',
      'Lee',
      'Lincoln',
      'Little River',
      'Logan',
      'Lonoke',
      'Madison',
      'Marion',
      'Miller',
      'Mississippi',
      'Monroe',
      'Montgomery',
      'Nevada',
      'Newton',
      'Ouachita',
      'Perry',
      'Phillips',
      'Pike',
      'Poinsett',
      'Polk',
      'Pope',
      'Prairie',
      'Pulaski',
      'Randolph',
      'Saline',
      'Scott',
      'Searcy',
      'Sebastian',
      'Sevier',
      'Sharp',
      'St. Francis',
      'Stone',
      'Union',
      'Van Buren',
      'Washington',
      'White',
      'Woodruff',
      'Yell',
    ],
    'California': [
      'Alameda',
      'Alpine',
      'Amador',
      'Butte',
      'Calaveras',
      'Colusa',
      'Contra Costa',
      'Del Norte',
      'El Dorado',
      'Fresno',
      'Glenn',
      'Humboldt',
      'Imperial',
      'Inyo',
      'Kern',
      'Kings',
      'Lake',
      'Lassen',
      'Los Angeles',
      'Madera',
      'Marin',
      'Mariposa',
      'Mendocino',
      'Merced',
      'Modoc',
      'Mono',
      'Monterey',
      'Napa',
      'Nevada',
      'Orange',
      'Placer',
      'Plumas',
      'Riverside',
      'Sacramento',
      'San Benito',
      'San Bernardino',
      'San Diego',
      'San Francisco',
      'San Joaquin',
      'San Luis Obispo',
      'San Mateo',
      'Santa Barbara',
      'Santa Clara',
      'Santa Cruz',
      'Shasta',
      'Sierra',
      'Siskiyou',
      'Solano',
      'Sonoma',
      'Stanislaus',
      'Sutter',
      'Tehama',
      'Trinity',
      'Tulare',
      'Tuolumne',
      'Ventura',
      'Yolo',
      'Yuba',
    ],
    'Colorado': [
      'Adams',
      'Alamosa',
      'Arapahoe',
      'Archuleta',
      'Baca',
      'Bent',
      'Boulder',
      'Broomfield',
      'Chaffee',
      'Cheyenne',
      'Clear Creek',
      'Conejos',
      'Costilla',
      'Crowley',
      'Custer',
      'Delta',
      'Denver',
      'Dolores',
      'Douglas',
      'Eagle',
      'El Paso',
      'Elbert',
      'Fremont',
      'Garfield',
      'Gilpin',
      'Grand',
      'Gunnison',
      'Hinsdale',
      'Huerfano',
      'Jackson',
      'Jefferson',
      'Kiowa',
      'Kit Carson',
      'La Plata',
      'Lake',
      'Larimer',
      'Las Animas',
      'Lincoln',
      'Logan',
      'Mesa',
      'Mineral',
      'Moffat',
      'Montezuma',
      'Montrose',
      'Morgan',
      'Otero',
      'Ouray',
      'Park',
      'Phillips',
      'Pitkin',
      'Prowers',
      'Pueblo',
      'Rio Blanco',
      'Rio Grande',
      'Routt',
      'Saguache',
      'San Juan',
      'San Miguel',
      'Sedgwick',
      'Summit',
      'Teller',
      'Washington',
      'Weld',
      'Yuma',
    ],
    'Connecticut': [
      'Fairfield',
      'Hartford',
      'Litchfield',
      'Middlesex',
      'New Haven',
      'New London',
      'Tolland',
      'Windham',
    ],
    'Delaware': ['Kent', 'New Castle', 'Sussex'],
    'Florida': [
      'Alachua',
      'Baker',
      'Bay',
      'Bradford',
      'Brevard',
      'Broward',
      'Calhoun',
      'Charlotte',
      'Citrus',
      'Clay',
      'Collier',
      'Columbia',
      'DeSoto',
      'Dixie',
      'Duval',
      'Escambia',
      'Flagler',
      'Franklin',
      'Gadsden',
      'Gilchrist',
      'Glades',
      'Gulf',
      'Hamilton',
      'Hardee',
      'Hendry',
      'Hernando',
      'Highlands',
      'Hillsborough',
      'Holmes',
      'Indian River',
      'Jackson',
      'Jefferson',
      'Lafayette',
      'Lake',
      'Lee',
      'Leon',
      'Levy',
      'Liberty',
      'Madison',
      'Manatee',
      'Marion',
      'Martin',
      'Miami-Dade',
      'Monroe',
      'Nassau',
      'Okaloosa',
      'Okeechobee',
      'Orange',
      'Osceola',
      'Palm Beach',
      'Pasco',
      'Pinellas',
      'Polk',
      'Putnam',
      'Santa Rosa',
      'Sarasota',
      'Seminole',
      'St. Johns',
      'St. Lucie',
      'Sumter',
      'Suwannee',
      'Taylor',
      'Union',
      'Volusia',
      'Wakulla',
      'Walton',
      'Washington',
    ],
    'Georgia': [
      'Appling',
      'Atkinson',
      'Bacon',
      'Baker',
      'Baldwin',
      'Banks',
      'Barrow',
      'Bartow',
      'Ben Hill',
      'Berrien',
      'Bibb',
      'Bleckley',
      'Brantley',
      'Brooks',
      'Bryan',
      'Bulloch',
      'Burke',
      'Butts',
      'Calhoun',
      'Camden',
      'Candler',
      'Carroll',
      'Catoosa',
      'Charlton',
      'Chatham',
      'Chattahoochee',
      'Chattooga',
      'Cherokee',
      'Clarke',
      'Clay',
      'Clayton',
      'Clinch',
      'Cobb',
      'Coffee',
      'Colquitt',
      'Columbia',
      'Cook',
      'Coweta',
      'Crawford',
      'Crisp',
      'Dade',
      'Dawson',
      'Decatur',
      'DeKalb',
      'Dodge',
      'Dooly',
      'Dougherty',
      'Douglas',
      'Early',
      'Echols',
      'Effingham',
      'Elbert',
      'Emanuel',
      'Evans',
      'Fannin',
      'Fayette',
      'Floyd',
      'Forsyth',
      'Franklin',
      'Fulton',
      'Gilmer',
      'Glascock',
      'Glynn',
      'Gordon',
      'Grady',
      'Greene',
      'Gwinnett',
      'Habersham',
      'Hall',
      'Hancock',
      'Haralson',
      'Harris',
      'Hart',
      'Heard',
      'Henry',
      'Houston',
      'Irwin',
      'Jackson',
      'Jasper',
      'Jeff Davis',
      'Jefferson',
      'Jenkins',
      'Johnson',
      'Jones',
      'Lamar',
      'Lanier',
      'Laurens',
      'Lee',
      'Liberty',
      'Lincoln',
      'Long',
      'Lowndes',
      'Lumpkin',
      'Macon',
      'Madison',
      'Marion',
      'McDuffie',
      'McIntosh',
      'Meriwether',
      'Miller',
      'Mitchell',
      'Monroe',
      'Montgomery',
      'Morgan',
      'Murray',
      'Muscogee',
      'Newton',
      'Oconee',
      'Oglethorpe',
      'Paulding',
      'Peach',
      'Pickens',
      'Pierce',
      'Pike',
      'Polk',
      'Pulaski',
      'Putnam',
      'Quitman',
      'Rabun',
      'Randolph',
      'Richmond',
      'Rockdale',
      'Schley',
      'Screven',
      'Seminole',
      'Spalding',
      'Stephens',
      'Stewart',
      'Sumter',
      'Talbot',
      'Taliaferro',
      'Tattnall',
      'Taylor',
      'Telfair',
      'Terrell',
      'Thomas',
      'Tift',
      'Toombs',
      'Towns',
      'Treutlen',
      'Troup',
      'Turner',
      'Twiggs',
      'Union',
      'Upson',
      'Walker',
      'Walton',
      'Ware',
      'Warren',
      'Washington',
      'Wayne',
      'Webster',
      'Wheeler',
      'White',
      'Whitfield',
      'Wilcox',
      'Wilkes',
      'Wilkinson',
      'Worth',
    ],
    'Hawaii': ['Hawaii', 'Honolulu', 'Kalawao', 'Kauai', 'Maui'],
    'Idaho': [
      'Ada',
      'Adams',
      'Bannock',
      'Bear Lake',
      'Benewah',
      'Bingham',
      'Blaine',
      'Boise',
      'Bonner',
      'Bonneville',
      'Boundary',
      'Butte',
      'Camas',
      'Canyon',
      'Caribou',
      'Cassia',
      'Clark',
      'Clearwater',
      'Custer',
      'Elmore',
      'Franklin',
      'Fremont',
      'Gem',
      'Gooding',
      'Idaho',
      'Jefferson',
      'Jerome',
      'Kootenai',
      'Latah',
      'Lemhi',
      'Lewis',
      'Lincoln',
      'Madison',
      'Minidoka',
      'Nez Perce',
      'Oneida',
      'Owyhee',
      'Payette',
      'Power',
      'Shoshone',
      'Teton',
      'Twin Falls',
      'Valley',
      'Washington',
    ],
    'Illinois': [
      'Adams',
      'Alexander',
      'Bond',
      'Boone',
      'Brown',
      'Bureau',
      'Calhoun',
      'Carroll',
      'Cass',
      'Champaign',
      'Christian',
      'Clark',
      'Clay',
      'Clinton',
      'Coles',
      'Cook',
      'Crawford',
      'Cumberland',
      'De Witt',
      'DeKalb',
      'Douglas',
      'DuPage',
      'Edgar',
      'Edwards',
      'Effingham',
      'Fayette',
      'Ford',
      'Franklin',
      'Fulton',
      'Gallatin',
      'Greene',
      'Grundy',
      'Hamilton',
      'Hancock',
      'Hardin',
      'Henderson',
      'Henry',
      'Iroquois',
      'Jackson',
      'Jasper',
      'Jefferson',
      'Jersey',
      'Jo Daviess',
      'Johnson',
      'Kane',
      'Kankakee',
      'Kendall',
      'Knox',
      'La Salle',
      'Lake',
      'Lawrence',
      'Lee',
      'Livingston',
      'Logan',
      'Macon',
      'Macoupin',
      'Madison',
      'Marion',
      'Marshall',
      'Mason',
      'Massac',
      'McDonough',
      'McHenry',
      'McLean',
      'Menard',
      'Mercer',
      'Monroe',
      'Montgomery',
      'Morgan',
      'Moultrie',
      'Ogle',
      'Peoria',
      'Perry',
      'Piatt',
      'Pike',
      'Pope',
      'Pulaski',
      'Putnam',
      'Randolph',
      'Richland',
      'Rock Island',
      'Saline',
      'Sangamon',
      'Schuyler',
      'Scott',
      'Shelby',
      'St. Clair',
      'Stark',
      'Stephenson',
      'Tazewell',
      'Union',
      'Vermilion',
      'Wabash',
      'Warren',
      'Washington',
      'Wayne',
      'White',
      'Whiteside',
      'Will',
      'Williamson',
      'Winnebago',
      'Woodford',
    ],
    'Indiana': [
      'Adams',
      'Allen',
      'Bartholomew',
      'Benton',
      'Blackford',
      'Boone',
      'Brown',
      'Carroll',
      'Cass',
      'Clark',
      'Clay',
      'Clinton',
      'Crawford',
      'Daviess',
      'De Kalb',
      'Dearborn',
      'Decatur',
      'Delaware',
      'Dubois',
      'Elkhart',
      'Fayette',
      'Floyd',
      'Fountain',
      'Franklin',
      'Fulton',
      'Gibson',
      'Grant',
      'Greene',
      'Hamilton',
      'Hancock',
      'Harrison',
      'Hendricks',
      'Henry',
      'Howard',
      'Huntington',
      'Jackson',
      'Jasper',
      'Jay',
      'Jefferson',
      'Jennings',
      'Johnson',
      'Knox',
      'Kosciusko',
      'La Porte',
      'Lagrange',
      'Lake',
      'Lawrence',
      'Madison',
      'Marion',
      'Marshall',
      'Martin',
      'Miami',
      'Monroe',
      'Montgomery',
      'Morgan',
      'Newton',
      'Noble',
      'Ohio',
      'Orange',
      'Owen',
      'Parke',
      'Perry',
      'Pike',
      'Porter',
      'Posey',
      'Pulaski',
      'Putnam',
      'Randolph',
      'Ripley',
      'Rush',
      'Scott',
      'Shelby',
      'Spencer',
      'St. Joseph',
      'Starke',
      'Steuben',
      'Sullivan',
      'Switzerland',
      'Tippecanoe',
      'Tipton',
      'Union',
      'Vanderburgh',
      'Vermillion',
      'Vigo',
      'Wabash',
      'Warren',
      'Warrick',
      'Washington',
      'Wayne',
      'Wells',
      'White',
      'Whitley',
    ],
    'Iowa': [
      'Adair',
      'Adams',
      'Allamakee',
      'Appanoose',
      'Audubon',
      'Benton',
      'Black Hawk',
      'Boone',
      'Bremer',
      'Buchanan',
      'Buena Vista',
      'Butler',
      'Calhoun',
      'Carroll',
      'Cass',
      'Cedar',
      'Cerro Gordo',
      'Cherokee',
      'Chickasaw',
      'Clarke',
      'Clay',
      'Clayton',
      'Clinton',
      'Crawford',
      'Dallas',
      'Davis',
      'Decatur',
      'Delaware',
      'Des Moines',
      'Dickinson',
      'Dubuque',
      'Emmet',
      'Fayette',
      'Floyd',
      'Franklin',
      'Fremont',
      'Greene',
      'Grundy',
      'Guthrie',
      'Hamilton',
      'Hancock',
      'Hardin',
      'Harrison',
      'Henry',
      'Howard',
      'Humboldt',
      'Ida',
      'Iowa',
      'Jackson',
      'Jasper',
      'Jefferson',
      'Johnson',
      'Jones',
      'Keokuk',
      'Kossuth',
      'Lee',
      'Linn',
      'Louisa',
      'Lucas',
      'Lyon',
      'Madison',
      'Mahaska',
      'Marion',
      'Marshall',
      'Mills',
      'Mitchell',
      'Monona',
      'Monroe',
      'Montgomery',
      'Muscatine',
      "O'Brien",
      'Osceola',
      'Page',
      'Palo Alto',
      'Plymouth',
      'Pocahontas',
      'Polk',
      'Pottawattamie',
      'Poweshiek',
      'Ringgold',
      'Sac',
      'Scott',
      'Shelby',
      'Sioux',
      'Story',
      'Tama',
      'Taylor',
      'Union',
      'Van Buren',
      'Wapello',
      'Warren',
      'Washington',
      'Wayne',
      'Webster',
      'Winnebago',
      'Winneshiek',
      'Woodbury',
      'Worth',
      'Wright',
    ],
    'Kansas': [
      'Allen',
      'Anderson',
      'Atchison',
      'Barber',
      'Barton',
      'Bourbon',
      'Brown',
      'Butler',
      'Chase',
      'Chautauqua',
      'Cherokee',
      'Cheyenne',
      'Clark',
      'Clay',
      'Cloud',
      'Coffey',
      'Comanche',
      'Cowley',
      'Crawford',
      'Decatur',
      'Dickinson',
      'Doniphan',
      'Douglas',
      'Edwards',
      'Elk',
      'Ellis',
      'Ellsworth',
      'Finney',
      'Ford',
      'Franklin',
      'Geary',
      'Gove',
      'Graham',
      'Grant',
      'Gray',
      'Greeley',
      'Greenwood',
      'Hamilton',
      'Harper',
      'Harvey',
      'Haskell',
      'Hodgeman',
      'Jackson',
      'Jefferson',
      'Jewell',
      'Johnson',
      'Kearny',
      'Kingman',
      'Kiowa',
      'Labette',
      'Lane',
      'Leavenworth',
      'Lincoln',
      'Linn',
      'Logan',
      'Lyon',
      'Marion',
      'Marshall',
      'McPherson',
      'Meade',
      'Miami',
      'Mitchell',
      'Montgomery',
      'Morris',
      'Morton',
      'Nemaha',
      'Neosho',
      'Ness',
      'Norton',
      'Osage',
      'Osborne',
      'Ottawa',
      'Pawnee',
      'Phillips',
      'Pottawatomie',
      'Pratt',
      'Rawlins',
      'Reno',
      'Republic',
      'Rice',
      'Riley',
      'Rooks',
      'Rush',
      'Russell',
      'Saline',
      'Scott',
      'Sedgwick',
      'Seward',
      'Shawnee',
      'Sheridan',
      'Sherman',
      'Smith',
      'Stafford',
      'Stanton',
      'Stevens',
      'Sumner',
      'Thomas',
      'Trego',
      'Wabaunsee',
      'Wallace',
      'Washington',
      'Wichita',
      'Wilson',
      'Woodson',
      'Wyandotte',
    ],
    'Kentucky': [
      'Adair',
      'Allen',
      'Anderson',
      'Ballard',
      'Barren',
      'Bath',
      'Bell',
      'Boone',
      'Bourbon',
      'Boyd',
      'Boyle',
      'Bracken',
      'Breathitt',
      'Breckenridge',
      'Bullitt',
      'Butler',
      'Caldwell',
      'Calloway',
      'Campbell',
      'Carlisle',
      'Carroll',
      'Carter',
      'Casey',
      'Christian',
      'Clark',
      'Clay',
      'Clinton',
      'Crittenden',
      'Cumberland',
      'Daviess',
      'Edmonson',
      'Elliott',
      'Estill',
      'Fayette',
      'Fleming',
      'Floyd',
      'Franklin',
      'Fulton',
      'Gallatin',
      'Garrard',
      'Grant',
      'Graves',
      'Grayson',
      'Green',
      'Greenup',
      'Hancock',
      'Hardin',
      'Harlan',
      'Harrison',
      'Hart',
      'Henderson',
      'Henry',
      'Hickman',
      'Hopkins',
      'Jackson',
      'Jefferson',
      'Jessamine',
      'Johnson',
      'Kenton',
      'Knott',
      'Knox',
      'Larue',
      'Laurel',
      'Lawrence',
      'Lee',
      'Leslie',
      'Letcher',
      'Lewis',
      'Lincoln',
      'Livingston',
      'Logan',
      'Lyon',
      'Madison',
      'Magoffin',
      'Marion',
      'Marshall',
      'Martin',
      'Mason',
      'McCracken',
      'McCreary',
      'McLean',
      'Meade',
      'Menifee',
      'Mercer',
      'Metcalfe',
      'Monroe',
      'Montgomery',
      'Morgan',
      'Muhlenberg',
      'Nelson',
      'Nicholas',
      'Ohio',
      'Oldham',
      'Owen',
      'Owsley',
      'Pendleton',
      'Perry',
      'Pike',
      'Powell',
      'Pulaski',
      'Robertson',
      'Rockcastle',
      'Rowan',
      'Russell',
      'Scott',
      'Shelby',
      'Simpson',
      'Spencer',
      'Taylor',
      'Todd',
      'Trigg',
      'Trimble',
      'Union',
      'Warren',
      'Washington',
      'Wayne',
      'Webster',
      'Whitley',
      'Wolfe',
      'Woodford',
    ],
    'Louisiana': [
      'Acadia',
      'Allen',
      'Ascension',
      'Assumption',
      'Avoyelles',
      'Beauregard',
      'Bienville',
      'Bossier',
      'Caddo',
      'Calcasieu',
      'Caldwell',
      'Cameron',
      'Catahoula',
      'Claiborne',
      'Concordia',
      'De Soto',
      'East Baton Rouge',
      'East Carroll',
      'East Feliciana',
      'Evangeline',
      'Franklin',
      'Grant',
      'Iberia',
      'Iberville',
      'Jackson',
      'Jefferson Davis',
      'Jefferson',
      'La Salle',
      'Lafayette',
      'Lafourche',
      'Lincoln',
      'Livingston',
      'Madison',
      'Morehouse',
      'Natchitoches',
      'Orleans',
      'Ouachita',
      'Plaquemines',
      'Pointe Coupee',
      'Rapides',
      'Red River',
      'Richland',
      'Sabine',
      'St. Bernard',
      'St. Charles',
      'St. Helena',
      'St. James',
      'St. John the Baptist',
      'St. Landry',
      'St. Martin',
      'St. Mary',
      'St. Tammany',
      'Tangipahoa',
      'Tensas',
      'Terrebonne',
      'Union',
      'Vermilion',
      'Vernon',
      'Washington',
      'Webster',
      'West Baton Rouge',
      'West Carroll',
      'West Feliciana',
      'Winn',
    ],
    'Maine': [
      'Androscoggin',
      'Aroostook',
      'Cumberland',
      'Franklin',
      'Hancock',
      'Kennebec',
      'Knox',
      'Lincoln',
      'Oxford',
      'Penobscot',
      'Piscataquis',
      'Sagadahoc',
      'Somerset',
      'Waldo',
      'Washington',
      'York',
    ],
    'Maryland': [
      'Allegany',
      'Anne Arundel',
      'Baltimore City',
      'Baltimore',
      'Calvert',
      'Caroline',
      'Carroll',
      'Cecil',
      'Charles',
      'Dorchester',
      'Frederick',
      'Garrett',
      'Harford',
      'Howard',
      'Kent',
      'Montgomery',
      "Prince George's",
      "Queen Anne's",
      'Somerset',
      "St. Mary's",
      'Talbot',
      'Washington',
      'Wicomico',
      'Worcester',
    ],
    'Massachusetts': [
      'Barnstable',
      'Berkshire',
      'Bristol',
      'Dukes',
      'Essex',
      'Franklin',
      'Hampden',
      'Hampshire',
      'Middlesex',
      'Nantucket',
      'Norfolk',
      'Plymouth',
      'Suffolk',
      'Worcester',
    ],
    'Michigan': [
      'Alcona',
      'Alger',
      'Allegan',
      'Alpena',
      'Antrim',
      'Arenac',
      'Baraga',
      'Barry',
      'Bay',
      'Benzie',
      'Berrien',
      'Branch',
      'Calhoun',
      'Cass',
      'Charlevoix',
      'Cheboygan',
      'Chippewa',
      'Clare',
      'Clinton',
      'Crawford',
      'Delta',
      'Dickinson',
      'Eaton',
      'Emmet',
      'Genesee',
      'Gladwin',
      'Gogebic',
      'Grand Traverse',
      'Gratiot',
      'Hillsdale',
      'Houghton',
      'Huron',
      'Ingham',
      'Ionia',
      'Iosco',
      'Iron',
      'Isabella',
      'Jackson',
      'Kalamazoo',
      'Kalkaska',
      'Kent',
      'Keweenaw',
      'Lake',
      'Lapeer',
      'Leelanau',
      'Lenawee',
      'Livingston',
      'Luce',
      'Mackinac',
      'Macomb',
      'Manistee',
      'Marquette',
      'Mason',
      'Mecosta',
      'Menominee',
      'Midland',
      'Missaukee',
      'Monroe',
      'Montcalm',
      'Montmorency',
      'Muskegon',
      'Newaygo',
      'Oakland',
      'Oceana',
      'Ogemaw',
      'Ontonagon',
      'Osceola',
      'Oscoda',
      'Otsego',
      'Ottawa',
      'Presque Isle',
      'Roscommon',
      'Saginaw',
      'Sanilac',
      'Schoolcraft',
      'Shiawassee',
      'St. Clair',
      'St. Joseph',
      'Tuscola',
      'Van Buren',
      'Washtenaw',
      'Wayne',
      'Wexford',
    ],
    'Minnesota': [
      'Aitkin',
      'Anoka',
      'Becker',
      'Beltrami',
      'Benton',
      'Big Stone',
      'Blue Earth',
      'Brown',
      'Carlton',
      'Carver',
      'Cass',
      'Chippewa',
      'Chisago',
      'Clay',
      'Clearwater',
      'Cook',
      'Cottonwood',
      'Crow Wing',
      'Dakota',
      'Dodge',
      'Douglas',
      'Faribault',
      'Fillmore',
      'Freeborn',
      'Goodhue',
      'Grant',
      'Hennepin',
      'Houston',
      'Hubbard',
      'Isanti',
      'Itasca',
      'Jackson',
      'Kanabec',
      'Kandiyohi',
      'Kittson',
      'Koochiching',
      'Lac qui Parle',
      'Lake of the Woods',
      'Lake',
      'Le Sueur',
      'Lincoln',
      'Lyon',
      'Mahnomen',
      'Marshall',
      'Martin',
      'McLeod',
      'Meeker',
      'Mille Lacs',
      'Morrison',
      'Mower',
      'Murray',
      'Nicollet',
      'Nobles',
      'Norman',
      'Olmsted',
      'Otter Tail',
      'Pennington',
      'Pine',
      'Pipestone',
      'Polk',
      'Pope',
      'Ramsey',
      'Red Lake',
      'Redwood',
      'Renville',
      'Rice',
      'Rock',
      'Roseau',
      'Scott',
      'Sherburne',
      'Sibley',
      'St. Louis',
      'Stearns',
      'Steele',
      'Stevens',
      'Swift',
      'Todd',
      'Traverse',
      'Wabasha',
      'Wadena',
      'Waseca',
      'Washington',
      'Watonwan',
      'Wilkin',
      'Winona',
      'Wright',
      'Yellow Medicine',
    ],
    'Mississippi': [
      'Adams',
      'Alcorn',
      'Amite',
      'Attala',
      'Benton',
      'Bolivar',
      'Calhoun',
      'Carroll',
      'Chickasaw',
      'Choctaw',
      'Claiborne',
      'Clarke',
      'Clay',
      'Coahoma',
      'Copiah',
      'Covington',
      'DeSoto',
      'Forrest',
      'Franklin',
      'George',
      'Greene',
      'Grenada',
      'Hancock',
      'Harrison',
      'Hinds',
      'Holmes',
      'Humphreys',
      'Issaquena',
      'Itawamba',
      'Jackson',
      'Jasper',
      'Jefferson',
      'Jefferson Davis',
      'Jones',
      'Kemper',
      'Lafayette',
      'Lamar',
      'Lauderdale',
      'Lawrence',
      'Leake',
      'Lee',
      'Leflore',
      'Lincoln',
      'Lowndes',
      'Madison',
      'Marion',
      'Marshall',
      'Monroe',
      'Montgomery',
      'Neshoba',
      'Newton',
      'Noxubee',
      'Oktibbeha',
      'Panola',
      'Pearl River',
      'Perry',
      'Pike',
      'Pontotoc',
      'Prentiss',
      'Quitman',
      'Rankin',
      'Scott',
      'Sharkey',
      'Simpson',
      'Smith',
      'Stone',
      'Sunflower',
      'Tallahatchie',
      'Tate',
      'Tippah',
      'Tishomingo',
      'Tunica',
      'Union',
      'Walthall',
      'Warren',
      'Washington',
      'Wayne',
      'Webster',
      'Wilkinson',
      'Winston',
      'Yalobusha',
      'Yazoo',
    ],
    'Missouri': [
      'Adair',
      'Andrew',
      'Atchison',
      'Audrain',
      'Barry',
      'Barton',
      'Bates',
      'Benton',
      'Bollinger',
      'Boone',
      'Buchanan',
      'Butler',
      'Caldwell',
      'Callaway',
      'Camden',
      'Cape Girardeau',
      'Carroll',
      'Carter',
      'Cass',
      'Cedar',
      'Chariton',
      'Christian',
      'Clark',
      'Clay',
      'Clinton',
      'Cole',
      'Cooper',
      'Crawford',
      'Dade',
      'Dallas',
      'Daviess',
      'Dent',
      'DeKalb',
      'Douglas',
      'Dunklin',
      'Franklin',
      'Gasconade',
      'Gentry',
      'Greene',
      'Grundy',
      'Harrison',
      'Henry',
      'Hickory',
      'Holt',
      'Howard',
      'Howell',
      'Iron',
      'Jackson',
      'Jasper',
      'Jefferson',
      'Johnson',
      'Knox',
      'Laclede',
      'Lafayette',
      'Lawrence',
      'Lewis',
      'Lincoln',
      'Linn',
      'Livingston',
      'Macon',
      'Madison',
      'Maries',
      'Marion',
      'McDonald',
      'Mercer',
      'Miller',
      'Mississippi',
      'Moniteau',
      'Monroe',
      'Montgomery',
      'Morgan',
      'New Madrid',
      'Newton',
      'Nodaway',
      'Oregon',
      'Osage',
      'Ozark',
      'Pemiscot',
      'Perry',
      'Pettis',
      'Phelps',
      'Pike',
      'Platte',
      'Polk',
      'Pulaski',
      'Putnam',
      'Ralls',
      'Randolph',
      'Ray',
      'Reynolds',
      'Ripley',
      'Saline',
      'Schuyler',
      'Scotland',
      'Scott',
      'Shannon',
      'Shelby',
      'St. Charles',
      'St. Clair',
      'St. Francois',
      'St. Louis city',
      'St. Louis',
      'Ste. Genevieve',
      'Stoddard',
      'Stone',
      'Sullivan',
      'Taney',
      'Texas',
      'Vernon',
      'Warren',
      'Washington',
      'Wayne',
      'Webster',
      'Worth',
      'Wright',
    ],
    'Montana': [
      'Beaverhead',
      'Big Horn',
      'Blaine',
      'Broadwater',
      'Carbon',
      'Carter',
      'Cascade',
      'Chouteau',
      'Custer',
      'Daniels',
      'Dawson',
      'Deer Lodge',
      'Fallon',
      'Fergus',
      'Flathead',
      'Gallatin',
      'Garfield',
      'Glacier',
      'Golden Valley',
      'Granite',
      'Hill',
      'Jefferson',
      'Judith Basin',
      'Lake',
      'Lewis and Clark',
      'Liberty',
      'Lincoln',
      'Madison',
      'McCone',
      'Meagher',
      'Mineral',
      'Missoula',
      'Musselshell',
      'Park',
      'Petroleum',
      'Phillips',
      'Pondera',
      'Powder River',
      'Powell',
      'Prairie',
      'Ravalli',
      'Richland',
      'Roosevelt',
      'Rosebud',
      'Sanders',
      'Sheridan',
      'Silver Bow',
      'Stillwater',
      'Sweet Grass',
      'Teton',
      'Toole',
      'Treasure',
      'Valley',
      'Wheatland',
      'Wibaux',
      'Yellowstone',
    ],
    'Nebraska': [
      'Adams',
      'Antelope',
      'Arthur',
      'Banner',
      'Blaine',
      'Boone',
      'Box Butte',
      'Boyd',
      'Brown',
      'Buffalo',
      'Burt',
      'Butler',
      'Cass',
      'Cedar',
      'Chase',
      'Cherry',
      'Cheyenne',
      'Clay',
      'Colfax',
      'Cuming',
      'Custer',
      'Dakota',
      'Dawes',
      'Dawson',
      'Deuel',
      'Dixon',
      'Dodge',
      'Douglas',
      'Dundy',
      'Fillmore',
      'Franklin',
      'Frontier',
      'Furnas',
      'Gage',
      'Garden',
      'Garfield',
      'Gosper',
      'Grant',
      'Greeley',
      'Hall',
      'Hamilton',
      'Harlan',
      'Hayes',
      'Hitchcock',
      'Holt',
      'Hooker',
      'Howard',
      'Jefferson',
      'Johnson',
      'Kearney',
      'Keith',
      'Keya Paha',
      'Kimball',
      'Knox',
      'Lancaster',
      'Lincoln',
      'Logan',
      'Loup',
      'Madison',
      'McPherson',
      'Merrick',
      'Morrill',
      'Nance',
      'Nemaha',
      'Nuckolls',
      'Otoe',
      'Pawnee',
      'Perkins',
      'Phelps',
      'Pierce',
      'Platte',
      'Polk',
      'Red Willow',
      'Richardson',
      'Rock',
      'Saline',
      'Sarpy',
      'Saunders',
      'Scotts Bluff',
      'Seward',
      'Sheridan',
      'Sherman',
      'Sioux',
      'Stanton',
      'Thayer',
      'Thomas',
      'Thurston',
      'Valley',
      'Washington',
      'Wayne',
      'Webster',
      'Wheeler',
      'York',
    ],
    'Nevada': [
      'Churchill',
      'Clark',
      'Douglas',
      'Elko',
      'Esmeralda',
      'Eureka',
      'Humboldt',
      'Lander',
      'Lincoln',
      'Lyon',
      'Mineral',
      'Nye',
      'Pershing',
      'Storey',
      'Washoe',
      'White Pine',
    ],
    'New Hampshire': [
      'Belknap',
      'Carroll',
      'Cheshire',
      'Coos',
      'Grafton',
      'Hillsboro',
      'Merrimack',
      'Rockingham',
      'Strafford',
      'Sullivan',
    ],
    'New Jersey': [
      'Atlantic',
      'Bergen',
      'Burlington',
      'Camden',
      'Cape May',
      'Cumberland',
      'Essex',
      'Gloucester',
      'Hudson',
      'Hunterdon',
      'Mercer',
      'Middlesex',
      'Monmouth',
      'Morris',
      'Ocean',
      'Passaic',
      'Salem',
      'Somerset',
      'Sussex',
      'Union',
      'Warren',
    ],
    'New Mexico': [
      'Bernalillo',
      'Catron',
      'Chaves',
      'Cibola',
      'Colfax',
      'Curry',
      'DeBaca',
      'Dona Ana',
      'Eddy',
      'Grant',
      'Guadalupe',
      'Harding',
      'Hidalgo',
      'Lea',
      'Lincoln',
      'Los Alamos',
      'Luna',
      'McKinley',
      'Mora',
      'Otero',
      'Quay',
      'Rio Arriba',
      'Roosevelt',
      'San Juan',
      'San Miguel',
      'Sandoval',
      'Santa Fe',
      'Sierra',
      'Socorro',
      'Taos',
      'Torrance',
      'Union',
      'Valencia',
    ],
    'New York': [
      'Albany',
      'Allegany',
      'Bronx',
      'Broome',
      'Cattaraugus',
      'Cayuga',
      'Chautauqua',
      'Chemung',
      'Chenango',
      'Clinton',
      'Columbia',
      'Cortland',
      'Delaware',
      'Dutchess',
      'Erie',
      'Essex',
      'Franklin',
      'Fulton',
      'Genesee',
      'Greene',
      'Hamilton',
      'Herkimer',
      'Jefferson',
      'Kings',
      'Lewis',
      'Livingston',
      'Madison',
      'Monroe',
      'Montgomery',
      'Nassau',
      'New York',
      'Niagara',
      'Oneida',
      'Onondaga',
      'Ontario',
      'Orange',
      'Orleans',
      'Oswego',
      'Otsego',
      'Putnam',
      'Queens',
      'Rensselaer',
      'Richmond',
      'Rockland',
      'Saratoga',
      'Schenectady',
      'Schoharie',
      'Schuyler',
      'Seneca',
      'St. Lawrence',
      'Steuben',
      'Suffolk',
      'Sullivan',
      'Tioga',
      'Tompkins',
      'Ulster',
      'Warren',
      'Washington',
      'Wayne',
      'Westchester',
      'Wyoming',
      'Yates',
    ],
    'North Carolina': [
      'Alamance',
      'Alexander',
      'Alleghany',
      'Anson',
      'Ashe',
      'Avery',
      'Beaufort',
      'Bertie',
      'Bladen',
      'Brunswick',
      'Buncombe',
      'Burke',
      'Cabarrus',
      'Caldwell',
      'Camden',
      'Carteret',
      'Caswell',
      'Catawba',
      'Chatham',
      'Cherokee',
      'Chowan',
      'Clay',
      'Cleveland',
      'Columbus',
      'Craven',
      'Cumberland',
      'Currituck',
      'Dare',
      'Davidson',
      'Davie',
      'Duplin',
      'Durham',
      'Edgecombe',
      'Forsyth',
      'Franklin',
      'Gaston',
      'Gates',
      'Graham',
      'Granville',
      'Greene',
      'Guilford',
      'Halifax',
      'Harnett',
      'Haywood',
      'Henderson',
      'Hertford',
      'Hoke',
      'Hyde',
      'Iredell',
      'Jackson',
      'Johnston',
      'Jones',
      'Lee',
      'Lenoir',
      'Lincoln',
      'Macon',
      'Madison',
      'Martin',
      'McDowell',
      'Mecklenburg',
      'Mitchell',
      'Montgomery',
      'Moore',
      'Nash',
      'New Hanover',
      'Northampton',
      'Onslow',
      'Orange',
      'Pamlico',
      'Pasquotank',
      'Pender',
      'Perquimans',
      'Person',
      'Pitt',
      'Polk',
      'Randolph',
      'Richmond',
      'Robeson',
      'Rockingham',
      'Rowan',
      'Rutherford',
      'Sampson',
      'Scotland',
      'Stanly',
      'Stokes',
      'Surry',
      'Swain',
      'Transylvania',
      'Tyrrell',
      'Union',
      'Vance',
      'Wake',
      'Warren',
      'Washington',
      'Watauga',
      'Wayne',
      'Wilkes',
      'Wilson',
      'Yadkin',
      'Yancey',
    ],
    'North Dakota': [
      'Adams',
      'Barnes',
      'Benson',
      'Billings',
      'Bottineau',
      'Bowman',
      'Burke',
      'Burleigh',
      'Cass',
      'Cavalier',
      'Dickey',
      'Divide',
      'Dunn',
      'Eddy',
      'Emmons',
      'Foster',
      'Golden Valley',
      'Grand Forks',
      'Grant',
      'Griggs',
      'Hettinger',
      'Kidder',
      'LaMoure',
      'Logan',
      'McHenry',
      'McIntosh',
      'McKenzie',
      'McLean',
      'Mercer',
      'Morton',
      'Mountrail',
      'Nelson',
      'Oliver',
      'Pembina',
      'Pierce',
      'Ramsey',
      'Ransom',
      'Renville',
      'Richland',
      'Rolette',
      'Sargent',
      'Sheridan',
      'Sioux',
      'Slope',
      'Stark',
      'Steele',
      'Stutsman',
      'Towner',
      'Traill',
      'Walsh',
      'Ward',
      'Wells',
      'Williams',
    ],
    'Ohio': [
      'Adams',
      'Allen',
      'Ashland',
      'Ashtabula',
      'Athens',
      'Auglaize',
      'Belmont',
      'Brown',
      'Butler',
      'Carroll',
      'Champaign',
      'Clark',
      'Clermont',
      'Clinton',
      'Columbiana',
      'Coshocton',
      'Crawford',
      'Cuyahoga',
      'Darke',
      'Defiance',
      'Delaware',
      'Erie',
      'Fairfield',
      'Fayette',
      'Franklin',
      'Fulton',
      'Gallia',
      'Geauga',
      'Greene',
      'Guernsey',
      'Hamilton',
      'Hancock',
      'Hardin',
      'Harrison',
      'Henry',
      'Highland',
      'Hocking',
      'Holmes',
      'Huron',
      'Jackson',
      'Jefferson',
      'Knox',
      'Lake',
      'Lawrence',
      'Licking',
      'Logan',
      'Lorain',
      'Lucas',
      'Madison',
      'Mahoning',
      'Marion',
      'Medina',
      'Meigs',
      'Mercer',
      'Miami',
      'Monroe',
      'Montgomery',
      'Morgan',
      'Morrow',
      'Muskingum',
      'Noble',
      'Ottawa',
      'Paulding',
      'Perry',
      'Pickaway',
      'Pike',
      'Portage',
      'Preble',
      'Putnam',
      'Richland',
      'Ross',
      'Sandusky',
      'Scioto',
      'Seneca',
      'Shelby',
      'Stark',
      'Summit',
      'Trumbull',
      'Tuscarawas',
      'Union',
      'Van Wert',
      'Vinton',
      'Warren',
      'Washington',
      'Wayne',
      'Williams',
      'Wood',
      'Wyandot',
    ],
    'Oklahoma': [
      'Adair',
      'Alfalfa',
      'Atoka',
      'Beaver',
      'Beckham',
      'Blaine',
      'Bryan',
      'Caddo',
      'Canadian',
      'Carter',
      'Cherokee',
      'Choctaw',
      'Cimarron',
      'Cleveland',
      'Coal',
      'Comanche',
      'Cotton',
      'Craig',
      'Creek',
      'Custer',
      'Delaware',
      'Dewey',
      'Ellis',
      'Garfield',
      'Garvin',
      'Grady',
      'Grant',
      'Greer',
      'Harmon',
      'Harper',
      'Haskell',
      'Hughes',
      'Jackson',
      'Jefferson',
      'Johnston',
      'Kay',
      'Kingfisher',
      'Kiowa',
      'Latimer',
      'Le Flore',
      'Lincoln',
      'Logan',
      'Love',
      'Major',
      'Marshall',
      'Mayes',
      'McClain',
      'McCurtain',
      'McIntosh',
      'Murray',
      'Muskogee',
      'Noble',
      'Nowata',
      'Okfuskee',
      'Oklahoma',
      'Okmulgee',
      'Osage',
      'Ottawa',
      'Pawnee',
      'Payne',
      'Pittsburg',
      'Pontotoc',
      'Pottawatomie',
      'Pushmataha',
      'Roger Mills',
      'Rogers',
      'Seminole',
      'Sequoyah',
      'Stephens',
      'Texas',
      'Tillman',
      'Tulsa',
      'Wagoner',
      'Washington',
      'Washita',
      'Woods',
      'Woodward',
    ],
    'Oregon': [
      'Baker',
      'Benton',
      'Clackamas',
      'Clatsop',
      'Columbia',
      'Coos',
      'Crook',
      'Curry',
      'Deschutes',
      'Douglas',
      'Gilliam',
      'Grant',
      'Harney',
      'Hood River',
      'Jackson',
      'Jefferson',
      'Josephine',
      'Klamath',
      'Lake',
      'Lane',
      'Lincoln',
      'Linn',
      'Malheur',
      'Marion',
      'Morrow',
      'Multnomah',
      'Polk',
      'Sherman',
      'Tillamook',
      'Umatilla',
      'Union',
      'Wallowa',
      'Wasco',
      'Washington',
      'Wheeler',
      'Yamhill',
    ],
    'Pennsylvania': [
      'Adams',
      'Allegheny',
      'Armstrong',
      'Beaver',
      'Bedford',
      'Berks',
      'Blair',
      'Bradford',
      'Bucks',
      'Butler',
      'Cambria',
      'Cameron',
      'Carbon',
      'Centre',
      'Chester',
      'Clarion',
      'Clearfield',
      'Clinton',
      'Columbia',
      'Crawford',
      'Cumberland',
      'Dauphin',
      'Delaware',
      'Elk',
      'Erie',
      'Fayette',
      'Forest',
      'Franklin',
      'Fulton',
      'Greene',
      'Huntingdon',
      'Indiana',
      'Jefferson',
      'Juniata',
      'Lackawanna',
      'Lancaster',
      'Lawrence',
      'Lebanon',
      'Lehigh',
      'Luzerne',
      'Lycoming',
      'McKean',
      'Mercer',
      'Mifflin',
      'Monroe',
      'Montgomery',
      'Montour',
      'Northampton',
      'Northumberland',
      'Perry',
      'Philadelphia',
      'Pike',
      'Potter',
      'Schuylkill',
      'Snyder',
      'Somerset',
      'Sullivan',
      'Susquehanna',
      'Tioga',
      'Union',
      'Venango',
      'Warren',
      'Washington',
      'Wayne',
      'Westmoreland',
      'Wyoming',
      'York',
    ],
    'Rhode Island': ['Bristol', 'Kent', 'Newport', 'Providence', 'Washington'],
    'South Carolina': [
      'Abbeville',
      'Aiken',
      'Allendale',
      'Anderson',
      'Bamberg',
      'Barnwell',
      'Beaufort',
      'Berkeley',
      'Calhoun',
      'Charleston',
      'Cherokee',
      'Chester',
      'Chesterfield',
      'Clarendon',
      'Colleton',
      'Darlington',
      'Dillon',
      'Dorchester',
      'Edgefield',
      'Fairfield',
      'Florence',
      'Georgetown',
      'Greenville',
      'Greenwood',
      'Hampton',
      'Horry',
      'Jasper',
      'Kershaw',
      'Lancaster',
      'Laurens',
      'Lee',
      'Lexington',
      'Marion',
      'Marlboro',
      'McCormick',
      'Newberry',
      'Oconee',
      'Orangeburg',
      'Pickens',
      'Richland',
      'Saluda',
      'Spartanburg',
      'Sumter',
      'Union',
      'Williamsburg',
      'York',
    ],
    'South Dakota': [
      'Aurora',
      'Beadle',
      'Bennett',
      'Bon Homme',
      'Brookings',
      'Brown',
      'Brule',
      'Buffalo',
      'Butte',
      'Campbell',
      'Charles Mix',
      'Clark',
      'Clay',
      'Codington',
      'Corson',
      'Custer',
      'Davison',
      'Day',
      'Deuel',
      'Dewey',
      'Douglas',
      'Edmunds',
      'Fall River',
      'Faulk',
      'Grant',
      'Gregory',
      'Haakon',
      'Hamlin',
      'Hand',
      'Hanson',
      'Harding',
      'Hughes',
      'Hutchinson',
      'Hyde',
      'Jackson',
      'Jerauld',
      'Jones',
      'Kingsbury',
      'Lake',
      'Lawrence',
      'Lincoln',
      'Lyman',
      'Marshall',
      'McCook',
      'McPherson',
      'Meade',
      'Mellette',
      'Miner',
      'Minnehaha',
      'Moody',
      'Pennington',
      'Perkins',
      'Potter',
      'Roberts',
      'Sanborn',
      'Shannon',
      'Spink',
      'Stanley',
      'Sully',
      'Todd',
      'Tripp',
      'Turner',
      'Union',
      'Walworth',
      'Yankton',
      'Ziebach',
    ],
    'Tennessee': [
      'Anderson',
      'Bedford',
      'Benton',
      'Bledsoe',
      'Blount',
      'Bradley',
      'Campbell',
      'Cannon',
      'Carroll',
      'Carter',
      'Cheatham',
      'Chester',
      'Claiborne',
      'Clay',
      'Cocke',
      'Coffee',
      'Crockett',
      'Cumberland',
      'Davidson',
      'Decatur',
      'DeKalb',
      'Dickson',
      'Dyer',
      'Fayette',
      'Fentress',
      'Franklin',
      'Gibson',
      'Giles',
      'Grainger',
      'Greene',
      'Grundy',
      'Hamblen',
      'Hamilton',
      'Hancock',
      'Hardeman',
      'Hardin',
      'Hawkins',
      'Haywood',
      'Henderson',
      'Henry',
      'Hickman',
      'Houston',
      'Humphreys',
      'Jackson',
      'Jefferson',
      'Johnson',
      'Knox',
      'Lake',
      'Lauderdale',
      'Lawrence',
      'Lewis',
      'Lincoln',
      'Loudon',
      'Macon',
      'Madison',
      'Marion',
      'Marshall',
      'Maury',
      'McMinn',
      'McNairy',
      'Meigs',
      'Monroe',
      'Montgomery',
      'Moore',
      'Morgan',
      'Obion',
      'Overton',
      'Perry',
      'Pickett',
      'Polk',
      'Putnam',
      'Rhea',
      'Roane',
      'Robertson',
      'Rutherford',
      'Scott',
      'Sequatchie',
      'Sevier',
      'Shelby',
      'Smith',
      'Stewart',
      'Sullivan',
      'Sumner',
      'Tipton',
      'Trousdale',
      'Unicoi',
      'Union',
      'Van Buren',
      'Warren',
      'Washington',
      'Wayne',
      'Weakley',
      'White',
      'Williamson',
      'Wilson',
    ],
    'Texas': [
      'Anderson',
      'Andrews',
      'Angelina',
      'Aransas',
      'Archer',
      'Armstrong',
      'Atascosa',
      'Austin',
      'Bailey',
      'Bandera',
      'Bastrop',
      'Baylor',
      'Bee',
      'Bell',
      'Bexar',
      'Blanco',
      'Borden',
      'Bosque',
      'Bowie',
      'Brazoria',
      'Brazos',
      'Brewster',
      'Briscoe',
      'Brooks',
      'Brown',
      'Burleson',
      'Burnet',
      'Caldwell',
      'Calhoun',
      'Callahan',
      'Cameron',
      'Camp',
      'Carson',
      'Cass',
      'Castro',
      'Chambers',
      'Cherokee',
      'Childress',
      'Clay',
      'Cochran',
      'Coke',
      'Coleman',
      'Collin',
      'Collingsworth',
      'Colorado',
      'Comal',
      'Comanche',
      'Concho',
      'Cooke',
      'Coryell',
      'Cottle',
      'Crane',
      'Crockett',
      'Crosby',
      'Culberson',
      'Dallam',
      'Dallas',
      'Dawson',
      'Deaf Smith',
      'Delta',
      'Denton',
      'DeWitt',
      'Dickens',
      'Dimmit',
      'Donley',
      'Duval',
      'Eastland',
      'Ector',
      'Edwards',
      'El Paso',
      'Ellis',
      'Erath',
      'Falls',
      'Fannin',
      'Fayette',
      'Fisher',
      'Floyd',
      'Foard',
      'Fort Bend',
      'Franklin',
      'Freestone',
      'Frio',
      'Gaines',
      'Galveston',
      'Garza',
      'Gillespie',
      'Glasscock',
      'Goliad',
      'Gonzales',
      'Gray',
      'Grayson',
      'Gregg',
      'Grimes',
      'Guadalupe',
      'Hale',
      'Hall',
      'Hamilton',
      'Hansford',
      'Hardeman',
      'Hardin',
      'Harris',
      'Harrison',
      'Hartley',
      'Haskell',
      'Hays',
      'Hemphill',
      'Henderson',
      'Hidalgo',
      'Hill',
      'Hockley',
      'Hood',
      'Hopkins',
      'Houston',
      'Howard',
      'Hudspeth',
      'Hunt',
      'Hutchinson',
      'Irion',
      'Jack',
      'Jackson',
      'Jasper',
      'Jeff Davis',
      'Jefferson',
      'Jim Hogg',
      'Jim Wells',
      'Johnson',
      'Jones',
      'Karnes',
      'Kaufman',
      'Kendall',
      'Kenedy',
      'Kent',
      'Kerr',
      'Kimble',
      'King',
      'Kinney',
      'Kleberg',
      'Knox',
      'La Salle',
      'Lamar',
      'Lamb',
      'Lampasas',
      'Lavaca',
      'Lee',
      'Leon',
      'Liberty',
      'Limestone',
      'Lipscomb',
      'Live Oak',
      'Llano',
      'Loving',
      'Lubbock',
      'Lynn',
      'Madison',
      'Marion',
      'Martin',
      'Mason',
      'Matagorda',
      'Maverick',
      'McCulloch',
      'McLennan',
      'McMullen',
      'Medina',
      'Menard',
      'Midland',
      'Milam',
      'Mills',
      'Mitchell',
      'Montague',
      'Montgomery',
      'Moore',
      'Morris',
      'Motley',
      'Nacogdoches',
      'Navarro',
      'Newton',
      'Nolan',
      'Nueces',
      'Ochiltree',
      'Oldham',
      'Orange',
      'Palo Pinto',
      'Panola',
      'Parker',
      'Parmer',
      'Pecos',
      'Polk',
      'Potter',
      'Presidio',
      'Rains',
      'Randall',
      'Reagan',
      'Real',
      'Red River',
      'Reeves',
      'Refugio',
      'Roberts',
      'Robertson',
      'Rockwall',
      'Runnels',
      'Rusk',
      'Sabine',
      'San Augustine',
      'San Jacinto',
      'San Patricio',
      'San Saba',
      'Schleicher',
      'Scurry',
      'Shackelford',
      'Shelby',
      'Sherman',
      'Smith',
      'Somervell',
      'Starr',
      'Stephens',
      'Sterling',
      'Stonewall',
      'Sutton',
      'Swisher',
      'Tarrant',
      'Taylor',
      'Terrell',
      'Terry',
      'Throckmorton',
      'Titus',
      'Tom Green',
      'Travis',
      'Trinity',
      'Tyler',
      'Upshur',
      'Upton',
      'Uvalde',
      'Val Verde',
      'Van Zandt',
      'Victoria',
      'Walker',
      'Waller',
      'Ward',
      'Washington',
      'Webb',
      'Wharton',
      'Wheeler',
      'Wichita',
      'Wilbarger',
      'Willacy',
      'Williamson',
      'Wilson',
      'Winkler',
      'Wise',
      'Wood',
      'Yoakum',
      'Young',
      'Zapata',
      'Zavala',
    ],
    'Utah': [
      'Beaver',
      'Box Elder',
      'Cache',
      'Carbon',
      'Daggett',
      'Davis',
      'Duchesne',
      'Emery',
      'Garfield',
      'Grand',
      'Iron',
      'Juab',
      'Kane',
      'Millard',
      'Morgan',
      'Piute',
      'Rich',
      'Salt Lake',
      'San Juan',
      'Sanpete',
      'Sevier',
      'Summit',
      'Tooele',
      'Uintah',
      'Utah',
      'Wasatch',
      'Washington',
      'Wayne',
      'Weber',
    ],
    'Vermont': [
      'Addison',
      'Bennington',
      'Caledonia',
      'Chittenden',
      'Essex',
      'Franklin',
      'Grand Isle',
      'Lamoille',
      'Orange',
      'Orleans',
      'Rutland',
      'Washington',
      'Windham',
      'Windsor',
    ],
    'Virginia': [
      'Accomack',
      'Albemarle',
      'Alleghany',
      'Amelia',
      'Amherst',
      'Appomattox',
      'Arlington',
      'Augusta',
      'Bath',
      'Bedford',
      'Bland',
      'Botetourt',
      'Brunswick',
      'Buchanan',
      'Buckingham',
      'Campbell',
      'Caroline',
      'Carroll',
      'Charles City',
      'Charlotte',
      'Chesterfield',
      'Clarke',
      'Craig',
      'Culpeper',
      'Cumberland',
      'Dickenson',
      'Dinwiddie',
      'Essex',
      'Fairfax',
      'Fauquier',
      'Floyd',
      'Fluvanna',
      'Franklin',
      'Frederick',
      'Giles',
      'Gloucester',
      'Goochland',
      'Grayson',
      'Greene',
      'Greensville',
      'Halifax',
      'Hanover',
      'Henrico',
      'Henry',
      'Highland',
      'Isle of Wight',
      'James City',
      'King and Queen',
      'King George',
      'King William',
      'Lancaster',
      'Lee',
      'Loudoun',
      'Louisa',
      'Lunenburg',
      'Madison',
      'Mathews',
      'Mecklenburg',
      'Middlesex',
      'Montgomery',
      'Nelson',
      'New Kent',
      'Northampton',
      'Northumberland',
      'Nottoway',
      'Orange',
      'Page',
      'Patrick',
      'Pittsylvania',
      'Powhatan',
      'Prince Edward',
      'Prince George',
      'Prince William',
      'Pulaski',
      'Rappahannock',
      'Richmond',
      'Roanoke',
      'Rockbridge',
      'Rockingham',
      'Russell',
      'Scott',
      'Shenandoah',
      'Smyth',
      'Southampton',
      'Spotsylvania',
      'Stafford',
      'Surry',
      'Sussex',
      'Tazewell',
      'Warren',
      'Washington',
      'Westmoreland',
      'Wise',
      'Wythe',
      'York',
    ],
    'Washington': [
      'Adams',
      'Asotin',
      'Benton',
      'Chelan',
      'Clallam',
      'Clark',
      'Columbia',
      'Cowlitz',
      'Douglas',
      'Ferry',
      'Franklin',
      'Garfield',
      'Grant',
      'Grays Harbor',
      'Island',
      'Jefferson',
      'King',
      'Kitsap',
      'Kittitas',
      'Klickitat',
      'Lewis',
      'Lincoln',
      'Mason',
      'Okanogan',
      'Pacific',
      'Pend Oreille',
      'Pierce',
      'San Juan',
      'Skagit',
      'Skamania',
      'Snohomish',
      'Spokane',
      'Stevens',
      'Thurston',
      'Wahkiakum',
      'Walla Walla',
      'Whatcom',
      'Whitman',
      'Yakima',
    ],
    'West Virginia': [
      'Barbour',
      'Berkeley',
      'Boone',
      'Braxton',
      'Brooke',
      'Cabell',
      'Calhoun',
      'Clay',
      'Doddridge',
      'Fayette',
      'Gilmer',
      'Grant',
      'Greenbrier',
      'Hampshire',
      'Hancock',
      'Hardy',
      'Harrison',
      'Jackson',
      'Jefferson',
      'Kanawha',
      'Lewis',
      'Lincoln',
      'Logan',
      'Marion',
      'Marshall',
      'Mason',
      'McDowell',
      'Mercer',
      'Mineral',
      'Mingo',
      'Monongalia',
      'Monroe',
      'Morgan',
      'Nicholas',
      'Ohio',
      'Pendleton',
      'Pleasants',
      'Pocahontas',
      'Preston',
      'Putnam',
      'Raleigh',
      'Randolph',
      'Ritchie',
      'Roane',
      'Summers',
      'Taylor',
      'Tucker',
      'Tyler',
      'Upshur',
      'Wayne',
      'Webster',
      'Wetzel',
      'Wirt',
      'Wood',
      'Wyoming',
    ],
    'Wisconsin': [
      'Adams',
      'Ashland',
      'Barron',
      'Bayfield',
      'Brown',
      'Buffalo',
      'Burnett',
      'Calumet',
      'Chippewa',
      'Clark',
      'Columbia',
      'Crawford',
      'Dane',
      'Dodge',
      'Door',
      'Douglas',
      'Dunn',
      'Eau Claire',
      'Florence',
      'Fond du Lac',
      'Forest',
      'Grant',
      'Green',
      'Green Lake',
      'Iowa',
      'Iron',
      'Jackson',
      'Jefferson',
      'Juneau',
      'Kenosha',
      'Kewaunee',
      'La Crosse',
      'Lafayette',
      'Langlade',
      'Lincoln',
      'Manitowoc',
      'Marathon',
      'Marinette',
      'Marquette',
      'Menominee',
      'Milwaukee',
      'Monroe',
      'Oconto',
      'Oneida',
      'Outagamie',
      'Ozaukee',
      'Pepin',
      'Pierce',
      'Polk',
      'Portage',
      'Price',
      'Racine',
      'Richland',
      'Rock',
      'Rusk',
      'Sauk',
      'Sawyer',
      'Shawano',
      'Sheboygan',
      'St. Croix',
      'Taylor',
      'Trempealeau',
      'Vernon',
      'Vilas',
      'Walworth',
      'Washburn',
      'Washington',
      'Waukesha',
      'Waupaca',
      'Waushara',
      'Winnebago',
      'Wood',
    ],
    'Wyoming': [
      'Albany',
      'Big Horn',
      'Campbell',
      'Carbon',
      'Converse',
      'Crook',
      'Fremont',
      'Goshen',
      'Hot Springs',
      'Johnson',
      'Laramie',
      'Lincoln',
      'Natrona',
      'Niobrara',
      'Park',
      'Platte',
      'Sheridan',
      'Sublette',
      'Sweetwater',
      'Teton',
      'Uinta',
      'Washakie',
      'Weston',
    ],
  },
  countryValues: {
    AF: 'Afghanistan',
    AX: 'Åland Islands',
    AL: 'Albania',
    DZ: 'Algeria',
    AS: 'American Samoa',
    AD: 'Andorra',
    AO: 'Angola',
    AI: 'Anguilla',
    AQ: 'Antarctica',
    AG: 'Antigua and Barbuda',
    AR: 'Argentina',
    AM: 'Armenia',
    AW: 'Aruba',
    AU: 'Australia',
    AT: 'Austria',
    AZ: 'Azerbaijan',
    BS: 'Bahamas',
    BH: 'Bahrain',
    BD: 'Bangladesh',
    BB: 'Barbados',
    BY: 'Belarus',
    BE: 'Belgium',
    BZ: 'Belize',
    BJ: 'Benin',
    BM: 'Bermuda',
    BT: 'Bhutan',
    BO: 'Bolivia',
    BA: 'Bosnia and Herzegovina',
    BW: 'Botswana',
    BV: 'Bouvet Island',
    BR: 'Brazil',
    IO: 'British Indian Ocean Territory',
    BN: 'Brunei Darussalam',
    BG: 'Bulgaria',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    KH: 'Cambodia',
    CM: 'Cameroon',
    CA: 'Canada',
    CV: 'Cape Verde',
    KY: 'Cayman Islands',
    CF: 'Central African Republic',
    TD: 'Chad',
    CL: 'Chile',
    CN: 'China',
    CX: 'Christmas Island',
    CC: 'Cocos (Keeling) Islands',
    CO: 'Colombia',
    KM: 'Comoros',
    CG: 'Congo',
    CD: 'Congo, The Democratic Republic of The',
    CK: 'Cook Islands',
    CR: 'Costa Rica',
    CI: "Cote D'ivoire",
    HR: 'Croatia',
    CU: 'Cuba',
    CY: 'Cyprus',
    CZ: 'Czech Republic',
    DK: 'Denmark',
    DJ: 'Djibouti',
    DM: 'Dominica',
    DO: 'Dominican Republic',
    EC: 'Ecuador',
    EG: 'Egypt',
    SV: 'El Salvador',
    GQ: 'Equatorial Guinea',
    ER: 'Eritrea',
    EE: 'Estonia',
    ET: 'Ethiopia',
    FK: 'Falkland Islands (Malvinas)',
    FO: 'Faroe Islands',
    FJ: 'Fiji',
    FI: 'Finland',
    FR: 'France',
    GF: 'French Guiana',
    PF: 'French Polynesia',
    TF: 'French Southern Territories',
    GA: 'Gabon',
    GM: 'Gambia',
    GE: 'Georgia',
    DE: 'Germany',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GR: 'Greece',
    GL: 'Greenland',
    GD: 'Grenada',
    GP: 'Guadeloupe',
    GU: 'Guam',
    GT: 'Guatemala',
    GG: 'Guernsey',
    GN: 'Guinea',
    GW: 'Guinea-bissau',
    GY: 'Guyana',
    HT: 'Haiti',
    HM: 'Heard Island and Mcdonald Islands',
    VA: 'Holy See (Vatican City State)',
    HN: 'Honduras',
    HK: 'Hong Kong',
    HU: 'Hungary',
    IS: 'Iceland',
    IN: 'India',
    ID: 'Indonesia',
    IR: 'Iran, Islamic Republic of',
    IQ: 'Iraq',
    IE: 'Ireland',
    IM: 'Isle of Man',
    IL: 'Israel',
    IT: 'Italy',
    JM: 'Jamaica',
    JP: 'Japan',
    JE: 'Jersey',
    JO: 'Jordan',
    KZ: 'Kazakhstan',
    KE: 'Kenya',
    KI: 'Kiribati',
    KP: "Korea, Democratic People's Republic of",
    KR: 'Korea, Republic of',
    KW: 'Kuwait',
    KG: 'Kyrgyzstan',
    LA: "Lao People's Democratic Republic",
    LV: 'Latvia',
    LB: 'Lebanon',
    LS: 'Lesotho',
    LR: 'Liberia',
    LY: 'Libyan Arab Jamahiriya',
    LI: 'Liechtenstein',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    MO: 'Macao',
    MK: 'Macedonia, The Former Yugoslav Republic of',
    MG: 'Madagascar',
    MW: 'Malawi',
    MY: 'Malaysia',
    MV: 'Maldives',
    ML: 'Mali',
    MT: 'Malta',
    MH: 'Marshall Islands',
    MQ: 'Martinique',
    MR: 'Mauritania',
    MU: 'Mauritius',
    YT: 'Mayotte',
    MX: 'Mexico',
    FM: 'Micronesia, Federated States of',
    MD: 'Moldova, Republic of',
    MC: 'Monaco',
    MN: 'Mongolia',
    ME: 'Montenegro',
    MS: 'Montserrat',
    MA: 'Morocco',
    MZ: 'Mozambique',
    MM: 'Myanmar',
    NA: 'Namibia',
    NR: 'Nauru',
    NP: 'Nepal',
    NL: 'Netherlands',
    AN: 'Netherlands Antilles',
    NC: 'New Caledonia',
    NZ: 'New Zealand',
    NI: 'Nicaragua',
    NE: 'Niger',
    NG: 'Nigeria',
    NU: 'Niue',
    NF: 'Norfolk Island',
    MP: 'Northern Mariana Islands',
    NO: 'Norway',
    OM: 'Oman',
    PK: 'Pakistan',
    PW: 'Palau',
    PS: 'Palestinian Territory, Occupied',
    PA: 'Panama',
    PG: 'Papua New Guinea',
    PY: 'Paraguay',
    PE: 'Peru',
    PH: 'Philippines',
    PN: 'Pitcairn',
    PL: 'Poland',
    PT: 'Portugal',
    PR: 'Puerto Rico',
    QA: 'Qatar',
    RE: 'Reunion',
    RO: 'Romania',
    RU: 'Russian Federation',
    RW: 'Rwanda',
    SH: 'Saint Helena',
    KN: 'Saint Kitts and Nevis',
    LC: 'Saint Lucia',
    PM: 'Saint Pierre and Miquelon',
    VC: 'Saint Vincent and The Grenadines',
    WS: 'Samoa',
    SM: 'San Marino',
    ST: 'Sao Tome and Principe',
    SA: 'Saudi Arabia',
    SN: 'Senegal',
    RS: 'Serbia',
    SC: 'Seychelles',
    SL: 'Sierra Leone',
    SG: 'Singapore',
    SK: 'Slovakia',
    SI: 'Slovenia',
    SB: 'Solomon Islands',
    SO: 'Somalia',
    ZA: 'South Africa',
    GS: 'South Georgia and The South Sandwich Islands',
    ES: 'Spain',
    LK: 'Sri Lanka',
    SD: 'Sudan',
    SR: 'Suriname',
    SJ: 'Svalbard and Jan Mayen',
    SZ: 'Swaziland',
    SE: 'Sweden',
    CH: 'Switzerland',
    SY: 'Syrian Arab Republic',
    TW: 'Taiwan',
    TJ: 'Tajikistan',
    TZ: 'Tanzania, United Republic of',
    TH: 'Thailand',
    TL: 'Timor-leste',
    TG: 'Togo',
    TK: 'Tokelau',
    TO: 'Tonga',
    TT: 'Trinidad and Tobago',
    TN: 'Tunisia',
    TR: 'Turkey',
    TM: 'Turkmenistan',
    TC: 'Turks and Caicos Islands',
    TV: 'Tuvalu',
    UG: 'Uganda',
    UA: 'Ukraine',
    AE: 'United Arab Emirates',
    GB: 'United Kingdom',
    US: 'United States',
    UM: 'United States Minor Outlying Islands',
    UY: 'Uruguay',
    UZ: 'Uzbekistan',
    VU: 'Vanuatu',
    VE: 'Venezuela',
    VN: 'Vietnam',
    VG: 'Virgin Islands, British',
    VI: 'Virgin Islands, U.S.',
    WF: 'Wallis and Futuna',
    EH: 'Western Sahara',
    YE: 'Yemen',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
  },
  get countryValuesNY() {
    // Removing PR as a country selection in NY and updating
    // CG description from 'Congo' to 'The Congo'
    const { PR, ...countryValuesNY } = this.countryValues;
    countryValuesNY.CG = 'The Congo';
    return countryValuesNY;
  },
  usTerritories: {
    AS: { code: 'AS', acordState: 'AS', description: 'American Samoa' },
    FM: { code: 'FM', acordState: 'FS', description: 'Micronesia, Federated States of' },
    GU: { code: 'GU', acordState: 'GU', description: 'Guam' },
    MH: { code: 'MH', acordState: 'MH', description: 'Marshall Islands' },
    MP: { code: 'MP', acordState: 'MP', description: 'Northern Mariana Islands' },
    PW: { code: 'PW', acordState: 'PW', description: 'Palau' },
    PR: { code: 'PR', acordState: 'PR', description: 'Puerto Rico' },
    UM: { code: 'UM', acordState: 'UW', description: 'United States Minor Outlying Islands' },
    US: { code: 'US', acordState: 'US', description: 'United States' },
    VI: { code: 'VI', acordState: 'VI', description: 'Virgin Islands, U.S.' },
  },
  childCareCosts: [
    {
      minAge: 0,
      maxAge: 5,
      range: {
        low: 7e3,
        medium: 9e3,
        high: 13e3,
      },
    },
    {
      minAge: 6,
      maxAge: 14,
      range: {
        low: 4e3,
        medium: 6500,
        high: 1e4,
      },
    },
  ],
  childCareCostStates: {
    AL: 'medium',
    AK: 'medium',
    AZ: 'medium',
    AR: 'medium',
    CA: 'medium',
    CO: 'high',
    CT: 'medium',
    DE: 'medium',
    DC: 'medium',
    FL: 'medium',
    GA: 'medium',
    HI: 'medium',
    ID: 'medium',
    IL: 'medium',
    IN: 'high',
    IA: 'medium',
    KS: 'high',
    KY: 'medium',
    LA: 'medium',
    ME: 'high',
    MD: 'medium',
    MA: 'high',
    MI: 'medium',
    MN: 'high',
    MO: 'medium',
    MS: 'medium',
    MT: 'medium',
    NE: 'medium',
    NV: 'medium',
    NH: 'medium',
    NJ: 'medium',
    NM: 'medium',
    NY: 'high',
    NC: 'medium',
    ND: 'medium',
    OH: 'medium',
    OK: 'medium',
    OR: 'high',
    PA: 'medium',
    RI: 'high',
    SC: 'medium',
    SD: 'medium',
    TN: 'medium',
    TX: 'medium',
    UT: 'medium',
    VT: 'high',
    VA: 'medium',
    WA: 'medium',
    WV: 'medium',
    WI: 'high',
    WY: 'medium',
  },
  healthCareCosts: {
    AL: [3e3, 6e3],
    AK: [3e3, 6e3],
    AZ: [2961, 5292],
    AR: [3e3, 6e3],
    CA: [2943, 6567],
    CO: [2777, 5939],
    CT: [3503, 8477],
    DE: [3e3, 6e3],
    DC: [3e3, 6e3],
    FL: [3191, 6527],
    GA: [3228, 7408],
    HI: [3e3, 6e3],
    ID: [3e3, 6e3],
    IL: [2843, 6317],
    IN: [2930, 6236],
    IA: [3e3, 6e3],
    KS: [3e3, 6e3],
    KY: [2740, 5980],
    LA: [3e3, 6e3],
    ME: [4061, 7260],
    MD: [3e3, 6e3],
    MA: [5142, 12388],
    MI: [3e3, 6e3],
    MN: [2978, 7013],
    MO: [2725, 5657],
    MS: [3e3, 6e3],
    MT: [3305, 5968],
    NE: [2950, 5979],
    NV: [3276, 6119],
    NH: [3427, 7672],
    NJ: [3e3, 6e3],
    NM: [3e3, 6e3],
    NY: [6630, 13296],
    NC: [3e3, 6e3],
    ND: [3e3, 6e3],
    OH: [2772, 5701],
    OK: [3220, 6128],
    OR: [3e3, 6e3],
    PA: [2873, 6381],
    RI: [4779, 11107],
    SC: [3204, 6128],
    SD: [3e3, 6e3],
    TN: [3150, 5957],
    TX: [3208, 6459],
    UT: [3e3, 6e3],
    VT: [3e3, 6e3],
    VA: [3229, 6383],
    WA: [3e3, 6e3],
    WV: [3e3, 6e3],
    WI: [3e3, 6e3],
    WY: [3e3, 6e3],
  },
  drivingViolationTypes: {
    'ACCI': 'Accident',
    'DISQ': 'Disqualification',
    'REIN': 'License Reinstated',
    'REVO': 'Revocation',
    'SUSP': 'Suspension',
    'CANC': 'Cancellation',
    'CONV': 'Conviction',
    'DEPT': 'Departmental Action',
    'F/R': 'Finanacial Responsibility',
    'MISC': 'Miscellaneous',
    'PROB': 'Probation',
    'VIOL': 'Violation',
    'WARN': 'Warning',
    'UNCL': 'Unclassified',
  },
  standardViolationClass: {
    '10000': 'Registration, Titling and Licensing',
    '20000': 'Financial Responsibility and Accidents',
    '30000': 'Moving Violations',
    '40000': 'Motorcycle Violations',
    '50000': 'Serious Offenses (including Serious Moving Violations)',
    '60000': 'Equipment Violations',
    '70000': 'Parking Violations',
    '80000': 'Miscellaneous',
    '00000': 'Uncategorized Citation or Assigned from MVR Status or Conditions',
  },
  measurementUnits: {
    '1': '%',
    '6': 'Degrees Fahrenheit',
    '8': 'HPF',
    '9': 'LPF',
    '19': 'U/L',
    '24': 'g%',
    '25': 'g/dL',
    '37': 'mg%',
    '40': 'mg/dL',
    '47': 'mmol/L',
    '63': 'ug/mL',
    '83': 'ng/mL',
  },
  acordBoolean: {
    '0': 'False',
    '1': 'True',
  },
  //TODO: to be removed https://massmutual.atlassian.net/browse/HL-5368
  labResultCodes: {
    '1': 'Positive',
    '2': 'Negative',
  },
  instantIdNASCodes: {
    '0': 'Nothing found for input criteria.',
    '1': 'Input SSN is associated with a different name and address.',
    '2': 'Input First name and Last name matched.',
    '3': 'Input First name and Address matched.',
    '4': 'Input First name and SSN matched.',
    '5': 'Input Last name and Address matched.',
    '6': 'Input Address and SSN matched.',
    '7': 'Input Last name and SSN matched.',
    '8': 'Input First name, Last name and Address matched.',
    '9': 'Input First name, Last name and SSN matched.',
    '10': 'Input First name, Address and SSN matched.',
    '11': 'Input Last name, Address and SSN matched.',
    '12': 'Input First name, Last name, Address and SSN matched.',
  },
  instantIdRiskCodes: {
    '2': 'The input SSN is reported as deceased',
    '3': 'The input SSN was issued prior to the input date-of-birth',
    '6': 'The input SSN is invalid',
    '19': 'Unable to verify name, address, SSN/TIN and phone',
    '26': 'Unable to verify SSN / TIN',
    '28': 'Unable to verify date-of-birth',
    '29': 'The input SSN/TIN may have been miskeyed',
    '32': 'The input name matches the Watch List file',
    '50': 'The input address matches a prison address',
    '71': 'The input SSN is not found in the public record',
    '72': 'The input SSN is associated with a different name and address',
    '76': 'The input name may have been miskeyed',
    '77': 'The input name was missing',
    '81': 'The input date-of-birth was missing or incomplete',
    '83': 'The input date-of-birth may have been miskeyed',
    '85': 'The input SSN was issued to a non-US citizen',
    'CA': 'The primary input address is a Commercial Mail Receiving Agency',
    'DI': 'The input identity is reported as deceased',
    'IS': 'Input SSN possibly randomly issued by SSA, but invalid when first associated with the input identity',
    'MI': 'Multiple identities associated with input social',
    'MS': 'Multiple SSNs reported with applicant',
    'NB': 'No date-of-birth reported for the input identity',
    'VA': 'The input address is a vacant address',
    'CL': 'The input SSN is not the primary SSN for the input identity',
    'IT': 'The input SSN is an TIN',
    'WL': 'The input name matches one or more of the non-OFAC global watchlist(s)',
  },
  instantIdWatchListCodes: {
    OFAC: 'OFFICE OF FOREIGN ASSET CONTROL',
    FBI: 'FBI FUGITIVES 10 MOST WANTED',
  },
  faceUnitSize: 1e3,
  maxIdCheckAttempts: 3,
  maxDrivingRecordAttempts: 3,
  progressById: {
    '1': 'Needs',
    '2': 'Quotes',
    '10': 'ApplyIntro',
    '11': 'ApplicationRegisterLogin',
    '12': 'ApplicationFill',
    '13': 'ApplicationSubmitted',
  },
  progress: {
    Needs: 1,
    Quotes: 2,
    ApplyIntro: 10,
    ApplicationRegisterLogin: 11,
    ApplicationFill: 12,
    ApplicationSubmitted: 13,
  },
  policyStatus: {
    issued: 'Issued',
    active: 'Active',
    lapsePending: 'LapsePending',
    lapsed: 'Lapsed',
    notTaken: 'NotTaken',
    canceled: 'Canceled',
    freeLooked: 'FreeLooked',
    rescinded: 'Rescinded',
    surrendered: 'Surrendered',
  },
  addressType: {
    home: {
      code: '1',
      desc: 'Home',
    },
    business: {
      code: '2',
      desc: 'Business',
    },
    mailing: {
      code: '17',
      desc: 'Mailing',
    },
  },
  phoneType: {
    home: {
      code: '1',
      desc: 'Home',
    },
    business: {
      code: '2',
      desc: 'Business',
    },
    mobile: {
      code: '12',
      desc: 'Mobile',
    },
  },
  allCountries: [
    'Afghanistan',
    'Albania',
    'Algeria',
    'American Samoa',
    'Andorra',
    'Angola',
    'Anguilla',
    'Antigua and Barbuda',
    'Argentina',
    'Armenia',
    'Aruba',
    'Australia',
    'Austria',
    'Azerbaijan',
    'Azores',
    'Bahamas',
    'Bahrain',
    'Bangladesh',
    'Barbados',
    'Belarus',
    'Belgium',
    'Belize',
    'Benin',
    'Bermuda',
    'Bhutan',
    'Bolivia',
    'Bosnia and Herzegovina',
    'Botswana',
    'Brazil',
    'Brunei Darussalam',
    'Bulgaria',
    'Burkina Faso',
    'Burundi',
    'Cabo Verde',
    'Cambodia',
    'Cameroon',
    'Canada',
    'Canary Islands',
    'Cape Verde',
    'Cayman Islands',
    'Central African Republic',
    'Chad',
    'Chechnya',
    'Chile',
    'China',
    'Colombia',
    'Comoros',
    'Congo',
    'Cook Islands',
    'Costa Rica',
    "Côte D'Ivoire",
    'Croatia',
    'Cuba',
    'Curacao',
    'Cyprus',
    'Czech Republic',
    'Democratic Republic of the Congo',
    'Denmark',
    'Djibouti',
    'Dominica',
    'Dominican Republic',
    'Ecuador',
    'Egypt',
    'El Salvador',
    'Equatorial Guinea',
    'Eritrea',
    'Estonia',
    'Ethiopia',
    'Falkland Islands',
    'Fiji',
    'Finland',
    'France',
    'French Guiana',
    'French Polynesia',
    'Gabon',
    'Gambia',
    'Georgia',
    'Germany',
    'Ghana',
    'Greece',
    'Greenland',
    'Grenada',
    'Guadeloupe',
    'Guatemala',
    'Guinea',
    'Guinea Bissau',
    'Guyana',
    'Haiti',
    'Holland',
    'Honduras',
    'Hong Kong',
    'Hungary',
    'Iceland',
    'India',
    'Indonesia',
    'Iran',
    'Iraq',
    'Ireland',
    'Israel (excluding Gaza and West Bank)',
    'Italy',
    'Jamaica',
    'Japan',
    'Jordan',
    'Kazakhstan',
    'Kenya',
    'Kiribati',
    'Kosovo',
    'Kuwait',
    'Kyrgyzstan',
    'Laos',
    'Latvia',
    'Lebanon',
    'Lesotho',
    'Liberia',
    'Libya',
    'Liechtenstein',
    'Lithuania',
    'Luxembourg',
    'Macau',
    'Macedonia',
    'Madagascar',
    'Madeira',
    'Malawi',
    'Malaysia',
    'Maldives',
    'Mali',
    'Malta',
    'Marshall Islands',
    'Martinique',
    'Mauritania',
    'Mauritius',
    'Mexico',
    'Micronesia',
    'Moldova',
    'Monaco',
    'Mongolia',
    'Montenegro',
    'Montserrat',
    'Morocco',
    'Mozambique',
    'Myanmar',
    'Namibia',
    'Nauru',
    'Nepal',
    'Netherlands',
    'Netherlands Antilles',
    'New Caledonia',
    'New Zealand',
    'Nicaragua',
    'Niger',
    'Nigeria',
    'Niue',
    'North Korea',
    'Northern Ireland',
    'Northern Mariana Islands',
    'Norway',
    'Oman',
    'Pakistan',
    'Palau',
    'Palestine (Gaza or the West Bank)',
    'Panama',
    'Papua New Guinea',
    'Paraguay',
    'Peru',
    'Philippines',
    'Poland',
    'Portugal',
    'Qatar',
    'Romania',
    'Russia (excluding Chechnya)',
    'Rwanda',
    'Saint Kitts and Nevis',
    'Saint Lucia',
    'Saint Martin',
    'Saint Thomas',
    'Saint Vincent and the Grenadines',
    'Saipan',
    'Samoa',
    'San Marino',
    'Sao Tome and Principe',
    'Saudi Arabia',
    'Senegal',
    'Serbia',
    'Seychelles',
    'Sierra Leone',
    'Singapore',
    'Slovakia',
    'Slovenia',
    'Solomon Islands',
    'Somalia',
    'South Africa',
    'South Korea',
    'South ‎Sudan',
    'Spain',
    'Sri Lanka',
    'Sudan',
    'Suriname',
    'Suriname',
    'Swaziland',
    'Sweden',
    'Switzerland',
    'Syria',
    'Taiwan',
    'Tajikistan',
    'Tanzania',
    'Thailand',
    'Timor-Leste',
    'Togo',
    'Tonga',
    'Tonga',
    'Trinidad and Tobago',
    'Tunisia',
    'Turkey',
    'Turkmenistan',
    'Turks and Caicos',
    'Tuvalu',
    'Uganda',
    'Ukraine',
    'United Arab Emirates',
    'United Kingdom',
    'Uruguay',
    'Uzbekistan',
    'Vanuatu',
    'Venezuela',
    'Vietnam',
    'Virgin Islands',
    'Yemen',
    'Yugoslavia',
    'Zambia',
    'Zimbabwe',
  ],
  aRatedCountries: [
    'Albania',
    'American Samoa',
    'Andorra',
    'Anguilla',
    'Antigua and Barbuda',
    'Argentina',
    'Aruba',
    'Australia',
    'Austria',
    'Azores',
    'Barbados',
    'Belgium',
    'Bermuda',
    'Bosnia and Herzegovina',
    'Brunei Darussalam',
    'Bulgaria',
    'Canada',
    'Canary Islands',
    'Cayman Islands',
    'Chile',
    'Cook Islands',
    'Croatia',
    'Curacao',
    'Cyprus',
    'Czech Republic',
    'Denmark',
    'Dominica',
    'Estonia',
    'Falkland Islands',
    'Finland',
    'France',
    'French Polynesia',
    'Germany',
    'Greece',
    'Greenland',
    'Grenada',
    'Guadeloupe',
    'Holland',
    'Hong Kong',
    'Hungary',
    'Iceland',
    'Ireland',
    'Israel (excluding Gaza and West Bank)',
    'Italy',
    'Japan',
    'South Korea',
    'Kuwait',
    'Latvia',
    'Liechtenstein',
    'Lithuania',
    'Luxembourg',
    'Macau',
    'Macedonia',
    'Madeira',
    'Malta',
    'Marshall Islands',
    'Martinique',
    'Monaco',
    'Montenegro',
    'Montserrat',
    'Netherlands',
    'Netherlands Antilles',
    'New Caledonia',
    'New Zealand',
    'Northern Ireland',
    'Northern Mariana Islands',
    'Norway',
    'Palau',
    'Poland',
    'Portugal',
    'Qatar',
    'Romania',
    'Saipan',
    'San Marino',
    'Serbia',
    'Singapore',
    'Slovakia',
    'Slovenia',
    'Spain',
    'Saint Kitts and Nevis',
    'Saint Lucia',
    'Saint Martin',
    'Saint Thomas',
    'Saint Vincent and the Grenadines',
    'Sweden',
    'Switzerland',
    'Taiwan',
    'Turks and Caicos',
    'United Arab Emirates',
    'United Kingdom',
    'Uruguay',
    'Virgin Islands',
  ],
  bRatedCountries: [
    'Armenia',
    'Azerbaijan',
    'Bahamas',
    'Belarus',
    'Bhutan',
    'Brazil',
    'Cape Verde',
    'China',
    'Costa Rica',
    'Ecuador',
    'Micronesia',
    'Fiji',
    'French Guiana',
    'Georgia',
    'Jamaica',
    'Jordan',
    'Kazakhstan',
    'Kosovo',
    'Maldives',
    'Mauritius',
    'Mexico',
    'Micronesia',
    'Mexico',
    'Moldova',
    'Mongolia',
    'Niue',
    'Oman',
    'Panama',
    'Paraguay',
    'Peru',
    'Russia (excluding Chechnya)',
    'Samoa',
    'Seychelles',
    'Suriname',
    'Tonga',
    'Trinidad and Tobago',
    'Turkey',
    'Ukraine',
    'Yugoslavia',
  ],
  mexicoRatedPlaces: [
    'Cabo San Lucas',
    'Manzanillo',
    'Quintana Roo',
    'Acapulco',
    'Puerto Vallarta',
    'Mexico City',
    'Guanajuato (including Leon)',
    'Monterrey',
    'Cancun',
    'San Jose del Cabo',
    'Playa del Carmen',
    'Puerto Escondido',
    'Cozumel',
    'Guadalajara',
    'Other',
  ],
  cRatedCountries: [
    'Bangladesh',
    'Belize',
    'Bolivia',
    'Botswana',
    'Comoros',
    'Dominican Republic',
    'El Salvador',
    'Guatemala',
    'Guyana',
    'Honduras',
    'India',
    'Indonesia',
    'Kiribati',
    'Kyrgyzstan',
    'Laos',
    'Lebanon',
    'Morocco',
    'Namibia',
    'Nauru',
    'Nepal',
    'Nicaragua',
    'Philippines',
    'Saudi Arabia',
    'Solomon Islands',
    'South Africa',
    'Sri Lanka',
    'Tajikistan',
    'Thailand',
    'Turkmenistan',
    'Tuvalu',
    'Uzbekistan',
    'Vanuatu',
    'Venezuela',
    'Vietnam',
  ],
  cancelNoValidAgentLicenseDays: 180,
  gracePeriodDays: 35,
  reinstatmentPeriodYrs: 3,
  TLICParamedDays: 120, //COVID enhancements change from 90 -> 120
  MUWParamedDays: 115, //COVID enhancements change from 30 -> 115
  MUWParamedGraceDaysBeforeCancel: 5, //COVID enhancements change from 15 -> 5
  refundDays: 10,
  verifyEligibilityDays: 7,
  AcceleratedConfirmDays: 7,
  cpSignatureDays: 14,
  cpSignatureAcceleratedDays: 29,
  advisorReplacementEsign: 3,
  TLICConfirmDays: 7,
  TLICConfirmDaysBeforeAutoDecline: 14,
  appConfirmDays: 7,
  appDataFixDays: 7,
  appNotCompleteDays: 7,
  idCheckFixDays: 14,
  signatureDays: 7,
  autoIssueEffAfterDays: 5,
  autoSendPolicyToCustomerWithoutAmendmentDays: 14,
  autoCancelPolicyAfterHoldDays: 30,
  autoCancelPolicyAfterAdvisorAppPacketEsign: 6,
  offerPreviewReminderDays: 15,
  appExpireReminderDays: 30,
  ranOutOfDaysForUWWithTLIC: 120,
  ranOutOfDaysForUWWithoutTLIC: 165,
  daysInBetweenToRemindInsurability: 75,
  emailToFixAppDataMins: 3,
  emailToCompleteAppMins: 3,
  emailUWDecisionMins: 3,
  emailToConfirmAcceleratedUwResultDays: 3,
  emailToConfirmInitialUwResultDays: 2,
  emailToConfirmPolicyIssueDays: 3,
  emailToConfirmCoverpathPolicyIssueDays: 20,
  emailToSignApplicationDays: 2,
  emailToRemindAdvisorEsignReplacementDays: 2,
  emailToRemindAdvisorEsignFluidless: 1,
  emailSaveAgeNotificationDays: 1,
  emailToScheduleParamedDays: 25, //COVID enhancements change from 5 -> 25
  emailToUploadNonCitizenDocsDays: 3,
  emailCoverageNotInforceDays: 5,
  emailInsuredForFollowUp: 2,
  emailToRemindAdvisorToAmendIntervalDays: 3,
  emailToInformAboutDelayForLiteTouch: 6,
  emailOpsForManualReviewIDCheckMins: 3,
  millimanDataIntervalSecs: 15,
  activityRetryIntervalSecs: 5,
  activityMaxRetryAttempts: 10,
  reuseExistingDataDays: 14,
  daysToScheduleAppsAppointment: 2,
  cutoffTime: {
    hr: 0,
    min: 0,
  },
  daysToShowHalfBirthdayMsg: 10,
  freeLookPeriodDays: 10,
  uwPolicySlaDays: 2,
  countryStateProvince: {
    US: {
      AL: 'Alabama',
      AK: 'Alaska',
      AZ: 'Arizona',
      AR: 'Arkansas',
      CA: 'California',
      CO: 'Colorado',
      CT: 'Connecticut',
      DE: 'Delaware',
      DC: 'District of Columbia',
      FL: 'Florida',
      GA: 'Georgia',
      HI: 'Hawaii',
      ID: 'Idaho',
      IL: 'Illinois',
      IN: 'Indiana',
      IA: 'Iowa',
      KS: 'Kansas',
      KY: 'Kentucky',
      LA: 'Louisiana',
      MS: 'Mississippi',
      ME: 'Maine',
      MD: 'Maryland',
      MA: 'Massachusetts',
      MI: 'Michigan',
      MN: 'Minnesota',
      MO: 'Missouri',
      MT: 'Montana',
      NE: 'Nebraska',
      NV: 'Nevada',
      NH: 'New Hampshire',
      NJ: 'New Jersey',
      NM: 'New Mexico',
      NY: 'New York',
      NC: 'North Carolina',
      ND: 'North Dakota',
      OH: 'Ohio',
      OK: 'Oklahoma',
      OR: 'Oregon',
      PA: 'Pennsylvania',
      PR: 'Puerto Rico',
      RI: 'Rhode Island',
      SC: 'South Carolina',
      SD: 'South Dakota',
      TN: 'Tennessee',
      TX: 'Texas',
      UT: 'Utah',
      VT: 'Vermont',
      VA: 'Virginia',
      WA: 'Washington',
      WV: 'West Virginia',
      WI: 'Wisconsin',
      WY: 'Wyoming',
    },
    CA: {
      AB: 'Alberta',
      BC: 'British Columbia',
      MB: 'Manitoba',
      NB: 'New Brunswick',
      NF: 'Newfoundland',
      NT: 'Northwest Territories',
      NS: 'Nova Scotia',
      ON: 'Ontario',
      PE: 'Prince Edward Island',
      QC: 'Quebec',
      SK: 'Saskatchewan',
      YT: 'Yukon Territory',
      NU: 'Nunavut',
    },
    AU: {
      ACT: 'Australian Capital Territory',
      NSW: 'New South Wales',
      NT: 'Northern Territory',
      QLD: 'Queensland',
      SA: 'South Australia',
      TAS: 'Tasmania',
      VIC: 'Victoria',
      WA: 'Western Australia',
      Other: 'other',
    },
    JP: {
      Aichi: 'Aichi',
      Akita: 'Akita',
      Aomori: 'Aomori',
      Chiba: 'Chiba',
      Ehime: 'Ehime',
      Fukui: 'Fukui',
      Fukuoka: 'Fukuoka',
      Fukushima: 'Fukushima',
      Gifu: 'Gifu',
      Gunma: 'Gunma',
      Hiroshima: 'Hiroshima',
      Hokkaido: 'Hokkaido',
      Hyogo: 'Hyogo',
      Ibaraki: 'Ibaraki',
      Ishikawa: 'Ishikawa',
      Iwate: 'Iwate',
      Kagawa: 'Kagawa',
      Kagoshima: 'Kagoshima',
      Kanagawa: 'Kanagawa',
      Kouchi: 'Kouchi',
      Kumamoto: 'Kumamoto',
      Kyoto: 'Kyoto',
      Mie: 'Mie',
      Miyagi: 'Miyagi',
      Miyazaki: 'Miyazaki',
      Nagano: 'Nagano',
      Nagasaki: 'Nagasaki',
      Nara: 'Nara',
      Niigata: 'Niigata',
      Oita: 'Oita',
      Okayama: 'Okayama',
      Okinawa: 'Okinawa',
      Osaka: 'Osaka',
      Saga: 'Saga',
      Saitama: 'Saitama',
      Shiga: 'Shiga',
      Shimane: 'Shimane',
      Shizuoka: 'Shizuoka',
      Tochigi: 'Tochigi',
      Tokushima: 'Tokushima',
      Tokyo: 'Tokyo',
      Tottori: 'Tottori',
      Toyama: 'Toyama',
      Wakayama: 'Wakayama',
      Yamagata: 'Yamagata',
      Yamaguchi: 'Yamaguchi',
      Yamanashi: 'Yamanashi',
      Other: 'Other',
    },
    MX: {
      AG: 'Aguascalientes',
      BJ: 'Baja California',
      BS: 'Baja California Sur',
      CP: 'Campeche',
      CH: 'Chiapas',
      CI: 'Chihuahua',
      CU: 'Coahuila',
      CL: 'Colima',
      DF: 'Distrito Federal',
      DG: 'Durango',
      GJ: 'Guanajuato',
      GR: 'Guerrero',
      HG: 'Hidalgo',
      JA: 'Jalisco',
      EM: 'México',
      MH: 'Michoacan',
      MR: 'Morelos',
      NA: 'Nayarit',
      NL: 'Nuevo León',
      OA: 'Oaxaca',
      PU: 'Puebla',
      QA: 'Querétaro',
      QR: 'Quintana Roo',
      SL: 'San Luis Potos',
      SI: 'Sinaloa',
      SO: 'Sonora',
      TA: 'Tabasco',
      TM: 'Tamaulipas',
      TL: 'Tlaxcala',
      VZ: 'Veracruz',
      YC: 'Yucatán',
      ZT: 'Zacatecas',
      Other: 'Other',
    },
    ZA: {
      Gauteng: 'Gauteng',
      Western_Cape: 'Western Cape',
      Northern_Province: 'Northern Province',
      Northwest_Province: 'Northwest Province',
      Kwa_Zulu_Natal: 'Kwa Zulu Natal',
      Eastern_Cape: 'Eastern Cape',
      Freestate: 'Freestate',
      Northern_Cape: 'Northern Cape',
      Mpumalanga: 'Mpumalanga',
      Other: 'Other',
    },
  },
  channelAssumptions: 'none',
  millimanMIBRuleCodes: {
    '3001': 'Red priority MIB code has appeared',
    '3043': 'ECG Sub-Code 8D',
    '3044': 'ECG Sub-Code 18',
    '2999': 'MIB Error',
    '8900': 'MIB Code 011',
    '8820': 'MIB Code 030: H',
    '3024': 'MIB Code 030: J',
    '8920': 'MIB Code 031',
    '8330': 'MIB Code 035',
    '8630': 'MIB Code 038',
    '3036': 'MIB Code 039: G',
    '3038': 'MIB Code 039: H',
    '3037': 'MIB Code 039: J',
    '8730': 'MIB Code 039: Other (Not G,J,H)',
    '8830': 'MIB Code 040',
    '8840': 'MIB Code 050',
    '8250': 'MIB Code 054',
    '8550': 'MIB Code 057: G',
    '3029': 'MIB IAI Uses MIB_IAI_IncludeSelfReportedHits, MIB_IAI_LookbackMonths and MIB_IAI_ReviewOverCount',
    '8890': 'MIB Code 100 OR 140',
    '8601': 'MIB Code 108',
    '8701': 'MIB Code 109',
    '8801': 'MIB Code 110',
    '8901': 'MIB Code 111',
    '8341': 'MIB Code 145',
    '8841': 'MIB Code 150',
    '8941': 'MIB Code 151',
    '8051': 'MIB Code 152',
    '8151': 'MIB Code 153',
    '3039': 'MIB Code 154: Site codes 240, 410, 560, 730, ???)',
    '8251': 'MIB Code 154: Site code 200',
    '8451': 'MIB Code 156',
    '8551': 'MIB Code 157',
    '8061': 'MIB Code 162',
    '8161': 'MIB Code 163',
    '8361': 'MIB Code 165',
    '8861': 'MIB Code 170',
    '8481': 'MIB Code 186',
    '8781': 'MIB Code 189',
    '8981': 'MIB Code 191',
    '8191': 'MIB Code 193',
    '8391': 'MIB Code 195',
    '8891': 'MIB Code 200',
    '8102': 'MIB Code 203',
    '8202': 'MIB Code 204',
    '8302': 'MIB Code 205',
    '8402': 'MIB Code 206',
    '8502': 'MIB Code 207',
    '8602': 'MIB Code 208',
    '3006': 'MIB Code 210: H',
    '8802': 'MIB Code 210: J',
    '3008': 'MIB Code 215: G',
    '8312': 'MIB Code 215: H',
    '3009': 'MIB Code 215: Other (Not G, H)',
    '8912': 'MIB Code 221',
    '8832': 'MIB Code 240',
    '8152': 'MIB Code 253',
    '8352': 'MIB Code 255',
    '8852': 'MIB Code 260',
    '8362': 'MIB Code 265',
    '8662': 'MIB Code 268',
    '8762': 'MIB Code 269',
    '8372': 'MIB Code 275: H,J,K',
    '3010': 'MIB Code 275: Other (Not H,J,K)',
    '3040': 'MIB Code 280: S',
    '8872': 'MIB Code 280: H,J,K',
    '8882': 'MIB Code 290',
    '8092': 'MIB Code 292',
    '8292': 'MIB Code 294',
    '8492': 'MIB Code 296',
    '8692': 'MIB Code 298',
    '8892': 'MIB Code 300',
    '8403': 'MIB Code 306',
    '8503': 'MIB Code 307: J',
    '8603': 'MIB Code 308',
    '8013': 'MIB Code 312',
    '8113': 'MIB Code 313',
    '8313': 'MIB Code 315: G',
    '3015': 'MIB Code 315: H',
    '3016': 'MIB Code 315: J',
    '3017': 'MIB Code 315: Other (Not G,H,J)',
    '8813': 'MIB Code 320: Other (Not W)',
    '3049': 'MIB Code 320: W',
    '8913': 'MIB Code 321',
    '8923': 'MIB Code 331',
    '8233': 'MIB Code 334',
    '8333': 'MIB Code 335',
    '8433': 'MIB Code 336',
    '8533': 'MIB Code 337',
    '8633': 'MIB Code 338',
    '8933': 'MIB Code 341',
    '8043': 'MIB Code 342',
    '8143': 'MIB Code 343: H,J',
    '3041': 'MIB Code 343: Other (Not H, J)',
    '8543': 'MIB Code 347',
    '8743': 'MIB Code 349',
    '8843': 'MIB Code 350',
    '8943': 'MIB Code 351',
    '8053': 'MIB Code 352',
    '8953': 'MIB Code 361',
    '8963': 'MIB Code 371',
    '8073': 'MIB Code 372',
    '8273': 'MIB Code 374',
    '8873': 'MIB Code 380',
    '8893': 'MIB Code 400',
    '8004': 'MIB Code 402',
    '8104': 'MIB Code 403',
    '8404': 'MIB Code 406: Other (Not G)',
    '3055': 'MIB Code 406: G',
    '8504': 'MIB Code 407',
    '3018': 'MIB Code 408: H,J,K',
    '8604': 'MIB Code 408: Other (Not H,J,K)',
    '8704': 'MIB Code 409',
    '8804': 'MIB Code 410',
    '3012': 'MIB Code 415: Other (Not G,H)',
    '8414': 'MIB Code 416',
    '8614': 'MIB Code 418',
    '8824': 'MIB Code 430',
    '8894': 'MIB Code 500',
    '8805': 'MIB Code 510',
    '8315': 'MIB Code 515',
    '8415': 'MIB Code 516',
    '8515': 'MIB Code 517',
    '8615': 'MIB Code 518',
    '8035': 'MIB Code 532',
    '8135': 'MIB Code 533',
    '8235': 'MIB Code 534',
    '8335': 'MIB Code 535',
    '8835': 'MIB Code 540',
    '8935': 'MIB Code 541',
    '8045': 'MIB Code 542',
    '8845': 'MIB Code 550',
    '8155': 'MIB Code 553',
    '8855': 'MIB Code 560',
    '8865': 'MIB Code 570',
    '8336': 'MIB Code 635',
    '8836': 'MIB Code 640',
    '8936': 'MIB Code 641',
    '8046': 'MIB Code 642',
    '8346': 'MIB Code 645',
    '8446': 'MIB Code 646',
    '8856': 'MIB Code 660',
    '8896': 'MIB Code 700',
    '8917': 'MIB Code 721: J',
    '3005': 'MIB Code 721: Not J',
    '3031': 'MIB Code 721 and (912 or 181)',
    '8027': 'MIB Code 722',
    '8827': 'MIB Code 730',
    '8837': 'MIB Code 740',
    '8997': 'MIB Code 801',
    '8808': 'MIB Code 810',
    '8518': 'MIB Code 817',
    '8838': 'MIB Code 840',
    '8048': 'MIB Code 842',
    '8348': 'MIB Code 845',
    '3020': 'MIB Code 900: Sub-code 16B',
    '3021': 'MIB Code 900: Sub-code 24C',
    '8898': 'MIB Code 900: Sub-code 3A',
    '3019': 'MIB Code 900: Sub-code 6B',
    '3033': 'MIB Code 900: Sub-code 6C',
    '3042': 'MIB Code 900: Sub-codes 1, 3C,D, 5B,7, 8C, 12A,B,C, 13A,B, 14A, 16A, D, 17B,C, 21B, 23B,C,D, 24B,D,E,F',
    '3050': 'MIB Code 900: Sub-codes 17A',
    '3034': 'MIB Code 900: Sub-codes 6A,22A,23A,24A',
    '3035':
      'MIB Code 900: Other Sub-codes (Not 3A,6A,6B,6C,16B,17A,22A,23A,24A,24C,1, 3C,D, 5B,7, 8C, D, 12A,B,C, 13A,B, 14A, 16A,D, 17B,C, 18, 21B, 23B,C,D, 24B,C,D,E,F)',
    '8909': 'MIB Code 911',
    '8219': 'MIB Code 914',
    '8319': 'MIB Code 915: H',
    '8419': 'MIB Code 916: J,K',
    '8519': 'MIB Code 917: J',
    '8719': 'MIB Code 919: H',
    '3051': 'MIB Code 919: J',
    '3045': 'MIB Code 919: Other (Not H,J)',
    '3052': 'MIB Code 921: G',
    '3053': 'MIB Code 921: H',
    '8919': 'MIB Code 921: J,K',
    '8129': 'MIB Code 923',
    '8229': 'MIB Code 924',
    '8329': 'MIB Code 925',
    '8429': 'MIB Code 926',
    '8529': 'MIB Code 927',
    '8929': 'MIB Code 931: Other (Not G,H)',
    '8239': 'MIB Code 934',
    '8339': 'MIB Code 935',
    '8049': 'MIB Code 942',
    '8249': 'MIB Code 944',
    '8449': 'MIB Code 946',
    '8749': 'MIB Code 949',
    '8949': 'MIB Code 951: H (51-69%)',
    '3022': 'MIB Code 951: J (<50%)',
    '8159': 'MIB Code 953: J',
    '8269': 'MIB Code 964',
    '8469': 'MIB Code 966',
    '8769': 'MIB Code 969',
    '8679': 'MIB Code 978: H',
    '8779': 'MIB Code 979',
    '8289': 'MIB Code 984',
    '8789': 'MIB Code 989',
    '8889': 'MIB Code 990: Other (Not G)',
    '8989': 'MIB Code 991',
    '8099': 'MIB Code 992: J',
    '8199': 'MIB Code 993',
    '8499': 'MIB Code 996: J',
    '8699': 'MIB Code 998',
    '723': 'MIB Indicates diabetes, but not Rx',
    '731': 'MIB Indicates diabetes with insulin, but Rx shows non-insulin only',
    '767': 'MIB - Diabetic neuropathy with insulin use',
    '790': 'MIB indicates hypertension, but not Rx',
    '792': 'MIB indicates diabetes with wound care Rx',
  },
  beneficiaryTypes: {
    'Spouse': '9',
    'Child': '13',
    'Other Named Individual': '1',
    'My Estate': '2',
    'Trust Under Will': '6',
    'Other Trust': '7',
    'Other Entity': '34',
  },
  policyDocTypes: {
    'Amendment': DocTypes.amendment,
    'a5030_mec': 'A5030',
    'App': DocTypes.Application,
    'AppSupplement': DocTypes.AdditionalDetails,
    'Aviation': DocTypes.AviationSupp,
    'Avocation': DocTypes.AvocationSupp,
    'ForeignTravel': DocTypes.TravelForm,
    'Bene': DocTypes.BeneDesgination,
    'Owner': DocTypes.OwnerDesignation,
    'ACBRDisclosure': DocTypes.ACBRDisclosure,
    'StateDisclosure': DocTypes.StateDisclosure,
    'MiscSupp': DocTypes.MiscSupp,
    'Packet': DocTypes.appPacket,
    'HIPPA': DocTypes.HIPPA,
    'Replace': DocTypes.Replace,
    'BasicIllustration': DocTypes.BasicIllustration,
    'A2200': DocTypes.A2200,
    'Visa/Green card': DocTypes.visa,
    'I-797': DocTypes.i797,
    'Archive': DocTypes.archive,
    'Identification': DocTypes.Identification,
    'CustomerUpload': DocTypes.CustomerUpload,
    'ThirdPartyPayer': DocTypes.ThirdPartyPayer,
    'CollateralAssignment': DocTypes.CollateralAssignment,
    'NonIncorporatedEntityOwner': DocTypes.NonIncorporatedEntityOwner,
    'EntityOwnershipNonMA': DocTypes.EntityOwnershipNonMA,
    'EntityOwnershipMA': DocTypes.EntityOwnershipMA,
    'Trust': DocTypes.Trust,
    'Insurability': DocTypes.Insurability,
    'FR2217': DocTypes.FR2217,
    'FR2200': DocTypes.FR2200,
    'CIRDisclosure': DocTypes.CIRDisclosure,
    'FR3010': DocTypes.FR3010,
  },
  CoverpathAppScreenShotFormName: 'ICC18A2200CP 0618',
  MMD_FL_InsuranceProducer: 'Yaron Ben-Zvi',
  MMD_FL_LicenseNumber: 'W269496',
  Metadata_Node_FormNumber: 'B00900',
  secondaryAddresseeDesignatedStates: {
    CAS: {
      CA: 'California',
      CT: 'Connecticut',
      FL: 'Florida',
      MT: 'Montana',
      ID: 'Idaho',
      RI: 'Rhode Island',
      VT: 'Vermont',
    },
    MMDirect: {
      CA: 'California',
      CT: 'Connecticut',
      FL: 'Florida',
      ID: 'Idaho',
      MT: 'Montana',
      RI: 'Rhode Island',
      VT: 'Vermont',
    },
  },
  smsCampaignVersion: 3,
  healthCategories: {
    excellent: 'excellent',
    veryGood: 'very good',
    good: 'good',
    fair: 'fair',
  },
  examOneDetails: {
    name: 'ExamOne',
    address: '10101 Renner Blvd',
    city: 'Lenexa',
    state: 'KS',
    zip: '66219',
  },
  insurerDetails: {
    name: 'Massachusetts Mutual Life Insurance Co',
    address: '1295 State Street',
    city: 'Springfield',
    state: 'MA',
    zip: '01111',
  },
  internalReplacementCompanies: {
    MassMutual: true,
  },
  groupReplacementStates: ['NY', 'KS', 'MI', 'WA'],
  holdAdvisorDeclineReviewDays: 14,
  mandrillRedoMinutes: 5,
  coverpathUnsupportedStatesWhole: ['NY', 'PR'], // TODO HL-41004: Remove 'NY' when NY is live for good. Need to account for MMD where NY is not supported
  coverpathUnsupportedStatesTerm: ['NY', 'PR'], // TODO HL-41004: Remove 'NY' when NY is live for good. Need to account for MMD where NY is not supported
};

export const EligibleToConvertToExistingWLProductTypes = [
  Product.productTypes.Whole.productCodes.CPL100,
  Product.productTypes.Whole.productCodes.CPL100A,
  Product.productTypes.Whole.productCodes.CPL65,
  Product.productTypes.Whole.productCodes.CPL65A,
];

export const ConversionCreditEligible = [
  Product.productTypes.Whole.productCodes.CPL100,
  Product.productTypes.Whole.productCodes.CPL100A,
];

export const SanderlingProductCodes = [
  Product.channels.MMTRAD.productCodes.MMTRADTerm,
  Product.channels.MMTRAD.productCodes.MMTRADTermECP,
  Product.channels.MMTRAD.productCodes.MMTRADWL100,
  Product.channels.MMTRAD.productCodes.MMTRADWL65,
  Product.channels.MMTRAD.productCodes.MMTRADWL20,
  Product.channels.MMOPM.productCodes.MMOPMTermAPT80,
  Product.channels.MMOPM.productCodes.MMOPMTerm,
];

function getChannelAssumptions(channel: string) {
  return ChannelAssumptions[channel];
}

export const Assumptions = _.extend(
  assumptions,
  { channel: getChannelAssumptions },
  { mibRuleCodes: assumptions.millimanMIBRuleCodes }
);
